// mockups for similar projects
// mobile app
// import fitme from '../../../assets/mockups/fitme.jpeg'
import gbcMockup from '../../../assets/mockups2/mockups/gbc.png'
// import rafikMockup from '../../../assets/mockups/ABU RAFIK BUTCHER.png'
import afronetaMockup from '../../../assets/mockups2/mockups/AfroNeta.png'
import ANIATPNA from '../../../assets/mockups2/mockups/ANIATPNA Mobile App.png'
import zipzap from '../../../assets/mockups/Zipzap talk.png'
import aura from '../../../assets/mockups2/mockups/Aura VPN.png'
// import BlinkBack from '../../../assets/mockups/BlinkBack.png'
// import blush from '../../../assets/mockups/blush.png'
// import BLOCKATIE from '../../../assets/mockups/BLOCKATIE.png'
// import flaty from '../../../assets/mockups/Flaty.pk.png'
// import gdrive from '../../../assets/mockups/Gdrive Final.png'
// import harmon from '../../../assets/mockups/Harmonized1.png'
// import meCloset from '../../../assets/mockups/MeCloset.png'
// import mego from '../../../assets/mockups/Mego Final.png'
// import noly from '../../../assets/mockups/Noly.png'
// import pakTruck from '../../../assets/mockups/PakTRuck.png'
// import quickly from '../../../assets/mockups/Quickly final mockup.png'
// import revealit from '../../../assets/mockups/Revealt.png'
import onthedotMockup from '../../../assets/mockups2/mockups/Service Booking App.png'
// import helth from '../../../assets/mockups/So Helthful.png'
// import filsx from '../../../assets/mockups/filsx.jpg'

// rafik

const rafik = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1782110142/Abu_Rafiq_Hero_Section_xm1lhd.png'
const top = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1782110136/top_cmiz5f.png'
const rafik1 = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1782110135/1_phcirl.png'
const rafik2 = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1782110135/2_canxmr.png'
const rafik3 = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1782110135/3_mtm6lj.png'
const cta = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1782110136/cta_ho1kwl.png'

// afroneta
const afroneta = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1784629856/Aferoneta_Hero_ppdzux.png'
const topafro = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1782110139/top_nxbyrk.png'
const afro1 = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1782110136/1_hjfkay.png'
const afro2 = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1782110140/2_qgsrij.png'
const afro3 = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1782110141/3_mjemhx.png'
const ctaafro = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1782110135/cta_nqvesb.png'

// onthedot
const onthedot = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1784629858/Service_Booking_Hero_gmet0k.png'
const toponthedot = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1782200669/top_qcg4m7.png'
const onthedot1 = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1782200654/1_kbiae1.png'
const onthedot2 = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1782200654/2_xygulf.png'
const onthedot3 = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1782200655/3_myui9y.png'
const ctaonthedot = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1782200661/cta_htruqw.png'

// gbc
const gbc = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1782199499/Desktop_-_22_gpun9x.png'
const topgbc = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1782199500/top_coqjcx.png'
const gbc1 = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1782199477/1_u9kx8m.png'
const gbc2 = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1782199478/2_jaj9if.png'
const gbc3 = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1782802066/Group_1686557314_xpwnfh.png'
const ctagbc = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1782199496/cta_dwsa7p.png'

// anipartna
const anipartna = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1782110144/thumbnail_nxuhjy.png'
const topanipartna = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1782110148/top_hrlmtr.png'
const anipartna1 = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1782110136/1_ysnkfs.png'
const anipartna2 = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1782110137/2_l9d3ry.png'
const anipartna3 = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1782110139/3_fpc70c.png'
const ctaanipartna = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1782110140/cta_mg18hi.png'

// auravpn
const auravpn = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1782110145/thumbnail_iqcbmu.png'
const topauravpn = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1782110144/top_rbsvoj.png'
const auravpn1 = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1782110142/1_jhf1u7.png'
const auravpn2 = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1782110147/2_nkniqg.png'
const auravpn3 = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1782110142/3_gfzdif.png'
const ctaauravpn = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1782110143/cta_em8jzl.png'

// Revealit
const revealit_thumb = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1784629857/Revealt_Hero_lyueai.png'
const revealit_top = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1782215557/Group_1686557090_yt1tir.png'
const revealit1 = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1782215557/Group_1686557167_humhqy.png'
const revealit2 =  'https://res.cloudinary.com/dxsr1xve0/image/upload/v1782215557/Group_1686557168_rfjtzn.png'
const revealit3 =   'https://res.cloudinary.com/dxsr1xve0/image/upload/v1782215557/Group_1686557169_notntz.png'
const revealit4 =   'https://res.cloudinary.com/dxsr1xve0/image/upload/v1782215557/Group_1686557181_aklf8q.png'

// PakTruck
const PakTruck_thumb = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1784629857/Pak_Truck_Hero_lvfuwd.png'
const PakTruck_top = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1782217514/Main_Feature_bwyigm.png' 
const PakTruck1 = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1782217472/Group_1686557167_voshjr.png'
const PakTruck2 = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1782217473/Group_1686557168_afexb4.png'
const PakTruck3 = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1782217474/Group_1686557169_syswpw.png'
const PakTruck4 = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1782217471/Bottam_jq76gs.png'

//BlinkBack
const BlinkBack_thumb = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1782217422/Hero_lh9yez.png'
const BlinkBack_top = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1782217424/Main_Feature_rejwro.png' 
const BlinkBack1 = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1782217417/Group_1686557167_rcb7bm.png'
const BlinkBack2 = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1782217419/Group_1686557168_d3vbqf.png'
const BlinkBack3 = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1782217420/Group_1686557169_smc5f4.png'
const BlinkBack4 = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1782217417/Bottam_ppaczd.png'

//Noly

const noly = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1782220271/Hero_acpikv.png'
const noly_top = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1782220275/Main_Feature_bc2prw.png'
const noly1 = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1782220262/Group_1686557167_mjrjey.png'
const noly2 = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1782220269/Group_1686557173_y7l9uw.png'
const noly3 = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1782220266/Group_1686557169_mvibwv.png'
const noly4 = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1782220260/Bottam_gp0ks9.png'

//Flatty
const flatty_thumb = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1784629856/Flaty_Hero_dmketq.png'
const flatty_top = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1782217386/Main_Feature_d0mddh.png'
const flatty1 = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1782217381/Group_1686557167_l4nibn.png'
const flatty2 = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1782217381/Group_1686557168_ba38oh.png'
const flatty3 = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1782217381/Group_1686557169_oehy9o.png'
const flatty4 = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1782217380/Bottam_vrnzi3.png'

//G-Drive
const GDrive_thumb = "https://res.cloudinary.com/dxsr1xve0/image/upload/v1782283241/Hero_nebbtn.png"
const GDrive_top = "https://res.cloudinary.com/dxsr1xve0/image/upload/v1782283241/Main_Feature_zfi5pb.png"
const GDrive1 = "https://res.cloudinary.com/dxsr1xve0/image/upload/v1782283240/Group_1686557167_twy83z.png"
const GDrive2 = "https://res.cloudinary.com/dxsr1xve0/image/upload/v1782283240/Group_1686557168_otfgfk.png"
const GDrive3 = "https://res.cloudinary.com/dxsr1xve0/image/upload/v1782283240/Group_1686557169_n9bquv.png"
const GDrive4 = "https://res.cloudinary.com/dxsr1xve0/image/upload/v1782283240/Bottam_dvr15h.png"

// MeCloset

const MeCloset_thumb = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1782545544/Hero_hs25ve.png'
const MeCloset_top = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1782545544/Main_Feature_ngb5dt.png'
const MeCloset1 = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1782545544/Group_1686557167_wdz9le.png'
const MeCloset2 = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1782545543/Group_1686557173_lxajyz.png'
const MeCloset3 = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1782545543/Group_1686557174_blhi8u.png'
const MeCloset4 = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1782545543/Bottam_x8ywmz.png'

// SafeChoice
const SafeChoice_thumb = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1782560352/Hero_xszv4u.png'
const SafeChoice_top = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1782560357/Main_Feature_hroaa4.png'
const SafeChoice1 = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1782560323/Group_1686557167_gddxma.png'
const SafeChoice2 = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1782560323/Group_1686557173_hhoshy.png'
const SafeChoice3 = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1782560343/Group_1686557174_prthwl.png'
const SafeChoice4 = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1782560323/Bottam_zxh9ih.png'

//YazBoz
const Yazboz_thumb = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1782561771/Hero_j5nn7i.png'
const Yazboz_top = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1782561772/Main_Feature_uknnzr.png'
const Yazboz1 = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1782561766/Group_1686557167_hht69q.png'
const Yazboz2 = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1782561767/Group_1686557168_blifkf.png'
const Yazboz3 = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1782561767/Group_1686557169_mrwqny.png'
const Yazboz4 = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1782561766/Bottam_pahrbm.png'


// FitMe 

const FitMe_thumb = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1784027909/FiTme_Hero_Section_kz4rax.png'
const FitMe_top = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1783593241/Main_Feature_cnntqm.png'
const FitMe_1 = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1783593236/1_mi4gnz.png'
const FitMe_2 = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1783593237/2_odosfb.png'
const FitMe_3 = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1783593237/3_aah9pa.png'
const FitMe_4 = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1783593238/Bottam_fh0yoq.png'




// MEGO 
const mego_thhumb = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1784028547/MEGO_Hero_Section_oalmrn.png'
const mego_top = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1783593155/Main_Feature_zznzct.png'
const mego_1 = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1783593154/1_nw8pmz.png'
const mego_2 = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1783593153/2_dh9ien.png'
const mego_3 = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1783593154/3_m95m2q.png'
const mego_4 = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1783593154/Bottam_jtussl.png'

// Mb Travel 
const MbTravel_thumb = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1783845123/MB_Travel_Hero_wyzr3j.png'
const MbTravel_top = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1783593214/Main_Feature_bywhdr.png'
const MbTravel1 = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1783593207/1_zrytrr.png'
const MbTravel2 = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1783593208/2_bamxx0.png'
const MbTravel3 = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1783593208/3_av0spy.png'
const MbTravel4 = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1783593209/Bottam_ppyhk8.png'

// Web Mockups


// UBK Towing 

const UbkTowing_thumb  = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1784121830/UBK_Towing_Hero_Section_tprlw3.png'
const UbkTowing_top  = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1782816200/Main_Feature_niff0t.png'
const UbkTowing1  = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1782816197/1_gwew9b.png'
const UbkTowing2  = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1786432600/UBK_1_b4izyv.png'
const UbkTowing3  = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1786432599/UBK_2_e4behd.png'


 // Field Trip 
 
 const FieldTrip_thumb = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1782816176/Hero_bxwsa2.png'
 const FieldTrip_top = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1782816177/Main_Feature_xo6if2.png'
 const FieldTrip1 = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1782816178/Studio-Display_zgwtex.png'
 const FieldTrip2 = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1782816172/3_lunqdn.png'
 const FieldTrip3 = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1782816173/4_tx2sdx.png'

 




// flaty web

const flattyweb_thumb = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1784123246/Flaty_Hero_isfgz6.png'
const flattyweb_top = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1782816183/Main_Feature_cdff4b.png'
const flattyweb1 = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1782816180/1_g83grc.png'
const flattyweb2 = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1782816180/2_tv230j.png'
const flattyweb3 = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1782816181/3_dvai0x.png'

// earning dashboard
const EarningDashboard_thumb = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1782816171/Hero_gynfxo.png'
const EarningDashboard_top = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1782816172/Main_Feature_ltoy9m.png'
const EarningDashboard1 = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1782816170/Group_1686557300_s7czte.png'
const EarningDashboard2 = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1782816168/Group_1686557296_kbqvai.png'
const EarningDashboard3 = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1782816169/Group_1686557299_delc8d.png'

// Pak Truck 
 
const pakTruck_thumb = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1782816189/Hero_jm7gcz.png'
const pakTruck_top = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1782816192/Main_Feature_cesskr.png'
const pakTruck1 = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1782816189/1_uwdkab.png'
const pakTruck2 = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1782816188/2_uvggg8.png'
const pakTruck3 = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1782816189/3_zu38jx.png'

// Supply King 

const SupplyKing_thumb = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1784121945/Supply_King_Hero_Section_n6imu7.png'
const SupplyKing_top = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1782816196/Main_Feature_hagb5u.png'
const SupplyKing1 = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1782816192/1_ksnnya.png'
const SupplyKing2 = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1782816193/2_cvl39s.png'
const SupplyKing3 = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1782816194/3_tmnlcv.png'

// We Sacle (WEB)

const WeScale_thumb = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1784127332/WE_Scale_Hero_ot8itl.png'
const WeScale_top = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1782816246/Main_Feature_jd65qy.png'
const WeScale1 = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1782816242/1_vpbhvq.png'
const WeScale2 = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1782816243/2_hppkuj.png'
const WeScale3 = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1782816243/3_fw32dh.png'

// Visaera WorldWide 

const visaera_thumb ='https://res.cloudinary.com/dxsr1xve0/image/upload/v1782816242/Hero_rlhall.png'
const visaera_top ='https://res.cloudinary.com/dxsr1xve0/image/upload/v1782816204/Main_Feature_buzcdb.png'
const visaera1 ='https://res.cloudinary.com/dxsr1xve0/image/upload/v1782816202/1_geoeww.png'
const visaera2 ='https://res.cloudinary.com/dxsr1xve0/image/upload/v1782816202/2_vaj5b8.png'
const visaera3 ='https://res.cloudinary.com/dxsr1xve0/image/upload/v1782816203/3_nqm2dt.png'

// Developers Door (Web)
const DevelopersDoor_thumb = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1784029543/Developer_Door_Hero_Section_upi9gz.png'
const DevelopersDoor_top = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1782816120/Main_Feature_yt3jlk.png'
const DevelopersDoor1 = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1782816120/1_iuko1t.png'
const DevelopersDoor2 = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1782816120/2_rfmqoz.png'
const DevelopersDoor3 = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1782816120/3_wcksg2.png'

// Glassgow Mobile Car Wash

const Glassgow_thumb = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1782816226/Hero_erg2dz.png'
const Glassgow_top = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1782816187/Main_Feature_i4gnnt.png'
const Glassgow1 = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1782816184/1_k0w0aj.png'
const Glassgow2 = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1782816184/2_s0wees.png'
const Glassgow3 = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1782816185/3_snipdc.png'


// BurnMobile Tyres 

const BurnMobile_thumb = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1783593323/Hero_p1jmhs.png'
const BurnMobile_top = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1783593325/Main_Feature_fhdryy.png'
const BurnMobile1 = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1783593321/1_q3jmab.png'
const BurnMobile2 = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1783593321/2_tz4lh5.png'
const BurnMobile3 = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1783593322/3_xazgzr.png'

 // SpecOptics //

 const Specoptics_thumb = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1784029684/SpectOptics_Hero_Section_ztg8ru.png'
 const Specoptics_top = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1783593441/Main_Feature_me8qjt.png'
 const Specoptics1 = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1783593434/1_yx2qft.png'
 const Specoptics2 = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1783593435/2_k68jaj.png'
 const Specoptics3 = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1783593436/3_dredjb.png'

//  Mobile Emissions

const MobileEmissions_thumb = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1783593280/Hero_cgixc2.png'
const MobileEmissions_top = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1783593280/Main_Feature_zrlfna.png'
const MobileEmissions1 = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1783593278/1_zazhmv.png'
const MobileEmissions2 = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1783593279/2_cpnylc.png'
const MobileEmissions3 = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1783593278/3_yp86xy.png'


// OXZ Market
const OXZMarket_hero = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1783593354/Hero_u3shav.png'
const OXZMarke_top = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1783593356/Main_Feature_dn2frb.png'
const OXZMarket1 = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1783593351/1_udwdbu.png'
const OXZMarket2 = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1783593351/2_mbdkr5.png'
const OXZMarket3 = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1783593353/3_l1fibk.png'

// Sohagan
const sohagan_hero = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1784629859/Sohaghan_Hero_h30pds.png'
const sohagan_top = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1783604497/Main_Feature_tz2rhq.png'
const sohagan1 = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1783604480/1_ekumy0.png'
const sohagan2 = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1783604482/2_wa8isp.png'
const sohagan3 = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1783604486/3_axdiec.png'

// Diamond Yarn 
const DiamondYarn_hero = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1783604538/Hero_gtalg5.png'
const DiamondYarn_top = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1783604544/Main_Feature_hdgdwc.png'
const DiamondYarn1 = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1783604525/1_tc9s9i.png'
const DiamondYarn2 = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1783604529/2_fcts96.png'
const DiamondYarn3 = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1783604533/3_fcatrs.png'

// vendCommm
const VendComm_hero = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1783604641/Hero_gqrhxv.png'
const VendComm_top = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1783604648/Main_Feature_lksnur.png'
const VendComm1 = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1783604626/1_o7flih.png'
const VendComm2 = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1783604630/2_lkry8c.png'
const VendComm3 = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1783604635/3_wd2hr0.png'


// vendcomm Dashbaord 
const VendCommDashboard_hero = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1784031951/Hero_q0o8p6.png'
const VendCommDashboard_top = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1783606321/Main_Feature_bnqust.png'
const VendCommDashboard1 = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1783606295/1_vidqgd.png'
const VendCommDashboard2 = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1783606298/2_tvp9zf.png'
const VendCommDashboard3 = 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1783606318/3_lymkqv.png'

const ProjectsData = {
  // Apps Section //
  "butcher-shop": {
    color: "#3fab21",
    shadeColor1: "#3FAB21",
    shadeColor2: "#3FAB21",

    thumbnail: rafik,
    topMedia: top,
    btn1Color: "#3FAB21",
    btn2Color: "#3FAB21",
    btn1: " Fresh Meat Categories",
    btn2: "Popular",
    leftContent: [
      {
        title: "User Profile Access",
        desc: "Quick access to your profile at the top, with your image, name, and action icons for calls and notifications.",
      },
      {
        title: "Smart Search Feature",
        desc: "Use the search bar to quickly find products with keywords for fast and accurate navigation throughout the app.",
      },
      {
        title: "Product Categories",
        desc: "Enjoy hassle-free browsing with organized product categories designed to help you discover items easily.",
      },
    ],

    rightContent: [
      {
        title: "Trending Products",
        desc: "Discover best-selling and in-demand products with our curated popular and trending highlights.",
      },
      {
        title: "Exclusive Offers",
        desc: "Enjoy instant access to special deals and limited-time promotions designed to give you the best savings.",
      },
      {
        title: "Smooth Navigation Bar",
        desc: "Navigate seamlessly between Home, Orders, Cart, and Offers anytime using our clean and simple bottom bar.",
      },
    ],

    bottom: {
      title: "Smart Product Suggestions",
      desc: "The system suggests relevant products to improve shopping experience.",
    },

    details: [
      {
        first: "image",
        image1: rafik1,
        title: "Order Placement <span class='text-[#3fab21]'>Checkout Process </span> Page",
        desc: "The Order Placement Page offers smooth checkout with delivery, pickup, or booking options, scheduled timing, location confirmation, multiple payment methods, and clear total before confirmation.",
      },
      {
        first: "text",
        image1: rafik2,
        title: "User <span class='text-[#3fab21]'>Notification Alert System</span> Page",
        desc: "The Notification Page shows real-time alerts, offers, updates, and service messages in a simple and organized layout, helping users stay informed and never miss important updates or opportunities.",
      },
      {
        first: "image",
        image1: rafik3,
        title: "<span class='text-[#3fab21]'>Order Tracking</span> Management System Page",
        desc: "The Order Placement Page offers smooth checkout with delivery, pickup, or booking options, scheduled timing, location confirmation, multiple payment methods, and clear totals before final confirmation.",
      },
    ],

    cta: {
      bg: "#72DE541F",
      ctaMedia: cta,
      title: "Order Tracking <span class='text-[#3fab21]'>Status Updates and User Feedback</span> System",
      text: "This system offers real-time order tracking and user feedback to improve experience and service quality.",
    },

    similarProjects: [
      {
        id: "gbc",
        title: "GBC",
        desc: "Connecting learners with mentors through interactive live learning.",
        image: "https://res.cloudinary.com/dxsr1xve0/image/upload/v1784114356/GBC_qyt1gs.png",
      },
      {
        id: "afroneta",
        title: "Afroneta",
        desc: "All-in-one platform for content, payments, and community management.",
        image: "https://res.cloudinary.com/dxsr1xve0/image/upload/v1783842887/AfroNeta_cpswek.png",
      },
      {
        id: "on-the-dot",
        title: "Service Booking",
        desc: "Seamless service booking with efficient business management.",
        image: "https://res.cloudinary.com/dxsr1xve0/image/upload/v1783842888/Service_Booking_App_zi2i3n.png",
      },
    ],
  },

  "afroneta": {
    color: "#6A1B9A",
    shadeColor1: "#6A1B9A",
    shadeColor2: "#FF7043",
    thumbnail: afroneta,
    topMedia: topafro,
    btn1Color: "#6A1B9A",
    btn2Color: "#FF7043",
    btn1: "Filter Your Matches",
    btn2: "Liked & Top Profiles",
    leftContent: [
      {
        title: "Smart Profile Matching",
        desc: "Connect with people using smart matching based on interests, preferences, and compatibility for better connections.",
      },
      {
        title: "Advanced Filters",
        desc: "Find nearby matches instantly. Filter by age, gender, and location to connect with the right people faster.",
      },
      {
        title: "Interactive Home Feed",
        desc: "Browse, connect, and chat instantly. Explore detailed profiles and start conversations with just a single tap.",
      },
    ],

    rightContent: [
      {
        title: "Upcoming Events",
        desc: " Explore upcoming events with complete details including date and time, and join to meet, socialize, and interact with new people easily.",
      },
      {
        title: "Matches & Connections",
        desc: "View your mutual matches in one place and instantly start conversations through simple, fast, and convenient messaging options anytime.",
      },
      {
        title: "Liked & Top Profiles",
        desc: " Access profiles you have liked and discover top or trending users to increase your chances of better and meaningful connections.",
      },
    ],

    bottom: {
      title: "Easy Communication",
      desc: "Connect without the hassle. Send likes, messages, and interact smoothly through a simple, clean interface",
    },

    details: [
      {
        first: "image",
        image1: afro1,
        title: "Discover & <span class='text-[#FF7043]'> Join Upcoming Events</span>",
        desc: "Browse all upcoming events with complete date and timing details, and easily join them directly through the app to meet and interact with new people in a more engaging way.",
      },
      {
        first: "text",
        image1: afro2,
        title: "Mutual<span class='text-[#FF7043]'> Matches & Connection</span> Screen",
        desc: "This page shows matched users based on profiles and interests. Users can view profiles, explore details, and start chatting with a simple “Hi” or “Hello”. It highlights mutual connections for easy interaction.",
      },
      {
        first: "image",
        image1: afro3,
        title: "<span class='text-[#FF7043]'>Liked & Trending Top</span> Profiles Section",
        desc: "This section shows liked profiles along with top and popular users for better discovery. Users can revisit profiles, view details, and explore trending users anytime. It improves match opportunities and makes browsing simple.",
      },
    ],

    cta: {
      bg: "#6A1B9A1F",
      ctaMedia: ctaafro,
      title: "Explore Profiles with <span class='text-[#FF7043]'> Advanced Filters and Communication</span> System",
      text: "Browse profiles using filters like gender and distance (up to KM) and connect instantly through smooth communication features.",
    },

    similarProjects: [
      {
        id: "gbc",
        title: "GBC",
        desc: "Connecting learners with mentors through interactive live learning.",
        image: "https://res.cloudinary.com/dxsr1xve0/image/upload/v1784114356/GBC_qyt1gs.png",
      },
      {
        id: "on-the-dot",
        title: "Service Booking",
        desc: "Seamless service booking with efficient business management.",
        image: "https://res.cloudinary.com/dxsr1xve0/image/upload/v1783842888/Service_Booking_App_zi2i3n.png",
      },
      {
        id: "revealit",
        title: "Revealit",
        desc: "Scan products for ingredients, allergens, and safety insights.",
        image: "https://res.cloudinary.com/dxsr1xve0/image/upload/v1783842886/Revealt_hpnmlu.png",
      },
    ],
  },

  "flatty": {
    color: "#fc9804",
    shadeColor1: "#FC9B04",
    shadeColor2: "#009740",
    thumbnail: flatty_thumb,
    topMedia: flatty_top,
    btn1Color: "#FC9B04",
    btn2Color: "#009740",
    btn1: "Property Features",
    btn2: "Verified Listings",
    leftContent: [
      {
        title: "Property Search",
        desc: "Easily search for your desired apartments, residential plots, or luxury houses directly from the main top search bar.",
      },
      {
        title: "Category Filters",
        desc: "Quickly filter available properties by selecting specific options to buy, sell, or browse all listings instantly on-screen.",
      },
      {
        title: "Popular Listings",
        desc: "Explore highly rated and most viewed hotel apartments or houses with high user ratings and verified reviews easily.",
      },
    ],
    rightContent: [
      {
        title: "Interactive Details",
        desc: "View essential property details like exact location, structural floor plans, and pricing per night without any extra effort.",
      },
      {
        title: " New Listings",
        desc: "Browse the latest added properties featuring beautiful thumbnail images, total bedroom counts, and complete bathroom data fields.",
      },
      {
        title: "Booking Appointments",
        desc: "Schedule direct visits or online appointments with real estate agents using the dedicated bottom navigation bar shortcut.",
      },
    ],
    bottom: {
      title: "Instant Messaging",
      desc: "Connect directly with property owners or verified dealers through a secure, built-in inbox system for smooth communication.",
    },
    details: [
      {
        first: "image",
        image1: flatty1,
        title: "<span class = 'text-[#009740]'>Fill Your Property</span> Specifications Here",
        desc: "The Add Property Page offers smooth listing with title entries, type dropdowns, square footage data, adjustable room counts, kitchen toggles, and clear feature selections before final submission.",
      },
      {
        first: "text",
        image1: flatty2,
        title: "Recent Chat <span class='text-[#009740]'> <br />Conversation Inbox</span> Screen",
        desc: "The Recent Chat Page offers smooth messaging with active text threads, real-time typing indicators, unread message badges, chronological timestamps, and clean bottom navigation before conversation selection.",
      },
      {
        first: "image",
        image1: flatty3,
        title: " Comprehensive <span class = 'text-[#009740]'>All in One Fitness</span> Experience",
        desc: "The Home Page shows rented houses, sold assets, transaction prices, and uploaded upload dates in a simple and organized layout, helping users manage listing records and never lose valuable tracking details or history.",
      },
    ],
    cta: {
      bg: "#FC9B0414",
      ctaMedia: flatty4,
      title: "Manage Your  <span class='text-[#fc9804]'>Property</span> Rented Details And <span class = 'text-[#fc9804]'>Booking</span> Appointments",
      text: "Track all active property rentals and schedule customer property viewings easily.",
    },
    similarProjects: [
      {
        id: "mecloset",
        title: "Me Closet",
        desc: "Organize outfits with a digital wardrobe and calendar.",
        image: "https://res.cloudinary.com/dxsr1xve0/image/upload/v1783842884/MeCloset_kdtflk.png",
      },
      {
        id: "blink-back",
        title: "Blink Back",
        desc: "Capture, organize, and relive your favorite memories effortlessly.",
        image: "https://res.cloudinary.com/dxsr1xve0/image/upload/v1783842883/BlinkBack_rnjct0.png",
      },
      {
        id: "gdrive",
        title: "GDrive",
        desc: "Interactive German driving test preparation with multimedia quizzes.",
        image: "https://res.cloudinary.com/dxsr1xve0/image/upload/v1783842882/Gdrive_Final_rl26qk.png",
      },
    ],
  },

  "mecloset": {
    color: "#7C3AED",
    shadeColor1: "#793FFF",
    shadeColor2: "#3AD4D4",
    thumbnail: MeCloset_thumb,
    topMedia: MeCloset_top,
    btn1Color: "#793FFF",
    btn2Color: "#3AD4D4",
    btn1: "Content Description Label",
    btn2: "Attribute Tag Status",

    leftContent: [
      {
        title: "Image Preview",
        desc: "View your selected character portrait or fashion model illustration clearly against a transparent grid background before saving.",
      },
      {
        title: " File Naming",
        desc: "Assign a custom unique title or professional identification name to your specific design project using this input field.",
      },
      {
        title: "Type Selection",
        desc: "Categorize your apparel item type dynamically by choosing specific structural options like top, bottom, or full outer clothing.",
      },
    ],

    rightContent: [
      {
        title: "Clothes Categories",
        desc: "Organize all your digital fashion pieces systematically into distinct style categories to maintain an efficient and clean wardrobe.",
      },
      {
        title: "Seasonal Tagging",
        desc: "Filter and tag your character outfits based on seasonal themes like hot summer, freezing winter, or beautiful autumn.",
      },
      {
        title: "Color Matching",
        desc: "Assign vibrant custom color values like bright yellow, deep blue, or soft pastel shades to your virtual fabrics.",
      },
    ],

    bottom: {
      title: " Save Changes",
      desc: "Apply and secure all your adjusted fashion parameters instantly by clicking the prominent gradient action button below.",
    },

    details: [
      {
        first: "image",
        image1: MeCloset1,
        title: "Smart <span class = 'text-[#793FFF]'>Wardrobe <br /></span> Outfit Browsing Page",
        desc: "The Closet Page shows clothing categories, occasion filters, favorited outfits, and visual wardrobe grids in a simple and organized layout, helping users plan their attire effortlessly and never struggle to find the perfect outfit.",
      },
      {
        first: "text",
        image1: MeCloset2,
        title: "Smart Wardrobe <span class = 'text-[#793FFF]'>Edit <br /> Categories</span> Page",
        desc: "The Categories Page shows category lists, item counts, modify options, and quick action buttons in a simple and organized layout, helping users manage their wardrobe groups effortlessly and never lose track of their personal collections.",
      },
      {
        first: "image",
        image1: MeCloset3,
        title: "Smart Category <br /> <span class = 'text-[#793FFF]'>Name Input</span>  Screen",
        desc: "The Input Page shows text entry fields, action submit buttons, and active system keyboards in a simple and organized layout, helping users update wardrobe labels effortlessly and never experience organization or setup delays.",
      },
    ],

    cta: {
      bg: "#793FFF1F",
      ctaMedia: MeCloset4,
      title: "Add Your <span class = 'text-[#793FFF]'>Clothes And <br /> Create Custom</span> Outfits",
      text: "The platform offers seamless custom outfit management with customizable wardrobe loyalty reward programs.",
    },

    similarProjects: [
      {
        id: "fitme",
        title: "FitMe - AI Outfit Stylist",
        desc: "AI-powered fashion styling with personalized outfit recommendations.",
        image: "https://res.cloudinary.com/dxsr1xve0/image/upload/v1783593243/Tanbnil_tlfije.png",
      },
      {
        id: "mego",
        title: "MEGO",
        desc: "Secure online marketplace with built-in rewards and benefits.",
        image: "https://res.cloudinary.com/dxsr1xve0/image/upload/v1783842885/Mego_cu6ids.png",
      },
      {
        id: "noly",
        title: "Noly",
        desc: "Convert audio into accurate transcripts and concise summaries.",
        image: "https://res.cloudinary.com/dxsr1xve0/image/upload/v1784029767/Noly_nbyhyw.png",
      },
    ],
  },

  "blink-back": {
    color: "#FF6B35",
    shadeColor1: "#FF6B35",
    shadeColor2: "#FF6B35",
    thumbnail: BlinkBack_thumb,
    topMedia: BlinkBack_top,
    btn1Color: "#FF6B35",
    btn2Color: "#FF6B35",
    btn1: "Map Marker Preview",
    btn2: "Location Detail Tag",

    leftContent: [
      {
        title: "Real-Time Navigation",
        desc: "Track your active drivers or friends on a live interactive map with precise, step-by-step location updates.",
      },
      {
        title: "Smart Search Bar",
        desc: "Easily search for specific addresses, local service zones, or popular public landmarks directly from the top search bar.",
      },
      {
        title: "Multiple Pin Views",
        desc: "Visualize multiple custom locations and active driver profiles pinned across the city streets simultaneously on one single screen.",
      },
    ],

    rightContent: [
      {
        title: "Direct Location Sharing",
        desc: "Share your current map coordinates instantly with your selected contacts or professional service providers for hassle-free tracking.",
      },
      {
        title: "Interactive Map Icons",
        desc: "Tap on any individual pin to open essential details, profile images, and quick shortcuts for communication instantly.",
      },
      {
        title: "Seamless Navigation Controls",
        desc: "Use intuitive on-screen buttons to quickly zoom, center your view, or add a brand new custom location pin.",
      },
    ],

    bottom: {
      title: "Saved Driver History",
      desc: "Access your comprehensive list of shared maps and recent routes directly through the bottom navigation bar effortlessly.",
    },

    details: [
      {
        first: "image",
        image1: BlinkBack1,
        title: "Location Details <span class='text-[#FF6B35]'>Edit Management</span> Page",
        desc: "The Edit Place Page offers seamless location customization with custom title inputs, country and city selectors, specific state or street details, scheduled dates, friend tagging, and a clear update button for final confirmation.",
      },
      {
        first: "text",
        image1: BlinkBack2,
        title: "Location Memory <span class='text-[#FF6B35]'>Details Overview</span> Page",
        desc: "The Memory Details Page offers seamless album browsing with smart filters for friends, dates, and categories, interactive media carousels, custom trip summaries, and quick navigation links to review all your location-specific travel highlights.",
      },
      {
        first: "image",
        image1: BlinkBack3,
        title: "Location Memories <span class='text-[#FF6B35]'>Creation Management</span> Page",
        desc: "The Add Memories Page offers smooth memory pinning with location selectors, visited dates, custom notes, emoji expressions, media uploads, and clear map submission before final confirmation.",
      },
    ],

    cta: {
      bg: "#FF6B3514",
      ctaMedia: BlinkBack4,
      title: "Interactive Location <span class='text-[#FF6B35]'>Loyalty And Shared Memories</span> Overview",
      text: "The Application Overview Page offers loyalty tracking with shared timelines, community maps, and profile insights before user engagement.",
    },

    similarProjects: [
      {
        id: "gbc",
        title: "GBC",
        desc: "Connecting learners with mentors through interactive live learning.",
        image: "https://res.cloudinary.com/dxsr1xve0/image/upload/v1784114356/GBC_qyt1gs.png",
      },
      {
        id: "anipartna",
        title: "Anipartna",
        desc: "Secure platform for buying, selling, and investing properties.",
        image: "https://res.cloudinary.com/dxsr1xve0/image/upload/v1783842882/ANIATPNA_Mobile_App_yspt0j.png",
      },
    ],
  },

  "on-the-dot": {
    color: "#0069FF",
    shadeColor1: "#0069FF",
    shadeColor2: "#0069FF",
    thumbnail: onthedot,
    topMedia: toponthedot,
    btn1Color: "#0069FF",
    btn2Color: "#0069FF",
    btn1: "Nearby Businesses",
    btn2: "Feature Businesses",
    leftContent: [
      {
        title: "Service Categories Overview",
        desc: "Browse different service categories including HVAC, electrical, plumbing, car dealing, pool cleaning, and house cleaning for all needs.",
      },
      {
        title: "HVAC Services Listing",
        desc: "Find heating, ventilation, and air conditioning services for installation, repair, and maintenance with trusted professionals in your area.",
      },
      {
        title: "Electrical Services Access",
        desc: "Connect with professional electricians for wiring, repairs, installations, and emergency electrical support with safe and reliable solutions.",
      },
    ],
    rightContent: [
      {
        title: "Plumbing Services Solutions",
        desc: "Access reliable plumbing services for leaks, pipe repairs, fittings, and complete water system maintenance with expert assistance.",
      },
      {
        title: "Car Dealing Services",
        desc: "Explore car buying and selling services with trusted dealers for smooth, secure, and hassle-free vehicle transactions.",
      },
      {
        title: "Nearby Business Discovery",
        desc: "Find nearby service providers based on your location for quick, easy, and convenient access to local businesses.",
      },
    ],

    bottom: {
      title: "Featured Business Listings",
      desc: "View highlighted businesses offering top-rated services for better quality, trust, and reliable customer experience every time.",
    },

    details: [
      {
        first: "image",
        image1: onthedot1,
        title: "Live <span class='text-[#0069FF]'>Map with Location</span> Tracking",
        desc: "View your current location on the map and easily navigate to home or other saved places with accurate directions. The map helps you explore nearby areas in real time and improves location tracking and navigation experience.",
      },
      {
        first: "text",
        image1: onthedot2,
        title: "All <span class='text-[#0069FF]'>Services Categories</span> Overview",
        desc: "Browse all available service categories in one place including different home, technical, and professional services.  Explore and select the required service based on your needs for quick access and better convenience.",
      },
      {
        first: "image",
        image1: onthedot3,
        title: "Service <span class='text-[#0069FF]'>Request, Category Selection & Scheduling </span>",
        desc: "Select a service category, upload a photo for reference, and specify when you need the service and preferred time. You can also add additional details to ensure accurate and quick service fulfillment.",
      },
    ],

    cta: {
      bg: "#0069FF14",
      ctaMedia: ctaonthedot,
      title: "Service Categories, <span class='text-[#0069FF]'> Nearby Businesses & Live Location Map </span> Overview",
      text: "Browse service categories, nearby and featured businesses, and view your live location on the map for easy navigation and quick access.",
    },

    similarProjects: [
      {
        id: "safe-choice",
        title: "SafeChoice",
        desc: "Scan products for health scores, allergen alerts, and smarter choices.",
        image: "https://res.cloudinary.com/dxsr1xve0/image/upload/v1783842886/SafeChoice_nk72vp.png",
      },
      // {
      //   id: "yazboz",
      //   title: "Yazboz",
      //   desc: "Track Okey scores, live matches, and complete game history with real-time updates.",
      //   image: "https://res.cloudinary.com/dxsr1xve0/image/upload/v1784114357/YAZBOZ_Updated_ri45bn.png",
      // },
      {
        id: "mb-travel",
        title: "MB Travel",
        desc: "Digital visa applications with secure document tracking.",
        image: "https://res.cloudinary.com/dxsr1xve0/image/upload/v1783669931/MB_Travel_Tanbnil_kyswqf.png",
      },
    ],
  },

  "gbc": {
    color: "#bf6900",
    shadeColor1: "#bf6900",
    shadeColor2: "#bf6900",
    thumbnail: gbc,
    topMedia: topgbc,
    btn1Color: "#bf6900",
    btn2Color: "#bf6900",
    btn1: "Upcoming Meetings",
    btn2: "Top Mentors",
    leftContent: [
      {
        title: "Search & Connect with Expert Mentors",
        desc: "Search mentors by skills, availability, and industry to find the right guidance for your goals and career growth.",
      },
      {
        title: "Advanced Mentor Filtering System",
        desc: "Use smart filters like skill, availability, and industry to quickly discover suitable mentors for your learning needs.",
      },
      {
        title: "Find Mentor Option",
        desc: "Easily find and connect with mentors based on your preferences to get personalized guidance and support.",
      },
    ],

    rightContent: [
      {
        title: "Q&A Forum for Learning Support",
        desc: "Ask questions and get answers from mentors and community members through an interactive Q&A forum.",
      },
      {
        title: "Job Forum for Opportunities",
        desc: "Explore job-related discussions and opportunities shared by mentors and professionals in the job forum section.",
      },
      {
        title: "Upcoming Meetings Schedule",
        desc: "View all upcoming mentor meetings with complete details to stay updated and never miss important sessions.",
      },
    ],

    bottom: {
      title: "Top Rated Mentors Showcase",
      desc: "Discover top mentors with ratings and reviews to choose the best guidance for your learning journey.",
    },

    details: [
      {
        first: "image",
        image1: gbc1,
        title: "Secure <span class='text-[#bf6900]'>Payments with Multiple</span> Options",
        desc: "Use saved cards or select Apple Pay, PayPal, Google Pay, or bank account for payment. Review your summary and complete the transaction securely with the Pay Now option.",
      },
      {
        first: "text",
        image1: gbc2,
        title: "Mentor <span class='text-[#bf6900]'>Profile, Skills & Experience</span> Overview",
        desc: "View complete mentor details including about section, skills, ratings, industry, and experience. Send a request to connect and get personalized guidance based on your learning needs.",
      },
      {
        first: "image",
        image1: gbc3,
        title: "Scheduled <span class='text-[#BF6900]'>Mentor Meeting Session</span> Details",
        desc: "Join your scheduled mentor meeting and view complete session details including time, topic, and mentor information. Stay connected to attend discussions and gain valuable guidance for your learning and career growth.",
      },
    ],

    cta: {
      bg: "#BF690014",
      ctaMedia: ctagbc,
      title: "Real Time <span class = 'text-[#bf6900]'>Tracking And Feedback</span> <br /> For Better Service",
      text: "This system offers real-time order tracking and user feedback to improve experience and service quality.",
    },

    similarProjects: [
      {
        id: "butcher-shop",
        title: "Abu Rafiq Butcher Shop",
        desc: "Seamless food ordering with delivery, pickup, and dine-in.",
        image: "https://res.cloudinary.com/dxsr1xve0/image/upload/v1783842882/ABU_RAFIK_BUTCHER_zmtlmz.png",
      },
      {
        id: "afroneta",
        title: "Afroneta",
        desc: "All-in-one platform for content, payments, and community management.",
        image: "https://res.cloudinary.com/dxsr1xve0/image/upload/v1783842887/AfroNeta_cpswek.png",
      },
      {
        id: "on-the-dot",
        title: "Service Booking",
        desc: "Seamless service booking with efficient business management.",
        image: "https://res.cloudinary.com/dxsr1xve0/image/upload/v1783842888/Service_Booking_App_zi2i3n.png",
      },
    ],
  },

  "anipartna": {
    color: "#099684",
    shadeColor1: "#099684",
    shadeColor2: "#006EDD",
    thumbnail: anipartna,
    topMedia: topanipartna,
    btn1Color: "#099684",
    btn2Color: "#006EDD",
    btn1: "Browse Businesses",
    btn2: "Featured partnership",
    leftContent: [
      {
        title: "Profile Verification & Setup",
        desc: "Update your profile with ID verification, address details, and complete information to ensure secure access and build trust within the platform.",
      },
      {
        title: "Business Investment Options",
        desc: "Explore a wide range of business investment opportunities that allow users to grow their portfolio and connect with potential partners easily.",
      },
      {
        title: "Property Investment Access",
        desc: "Invest in property projects by viewing detailed information, analyzing options, and choosing secure opportunities for better and long-term returns.",
      },
    ],

    rightContent: [
      {
        title: "Project & Venture Opportunities",
        desc: "Join different ventures and participate in projects to collaborate with others and expand your business network effectively.",
      },
      {
        title: "Loan & Acquisition Services",
        desc: "Access loan options, acquire businesses, or buy shares with flexible solutions designed to support your financial and business growth.",
      },
      {
        title: "Featured Partnership Openings",
        desc: "Discover featured partnership opportunities highlighted within the app to connect with serious investors and reliable collaborators.",
      },
    ],

    bottom: {
      title: "Trending Projects & Listings",
      desc: "Browse trending projects and active listings to explore the most popular investment opportunities.",
    },

    details: [
      {
        first: "image",
        image1: anipartna1,
        title: "Apply & Explore <span class='text-[#099684]'>Open Project Details</span>",
        desc: "Apply for a project directly and view complete details like feasibility analysis, company information, and project purpose. It also includes insights, recommendations, and a PDF report for better understanding before applying.",
      },
      {
        first: "text",
        image1: anipartna2,
        title: "Project <span class='text-[#099684]'>Details & Financial </span> Overview",
        desc: "View project media, about section, creator details, and team size. Also explore financial insights including revenue, expenses, profit, and budget for better understanding and decision-making.",
      },
      {
        first: "image",
        image1: anipartna3,
        title: "Loan <span class='text-[#099684]'>Marketplace Overview</span> & Requests",
        desc: "View loan giver details, browse loan seekers, and explore featured loan requests along with other available requests for better understanding. Compare options easily to make quick and informed loan decisions.",
      },
    ],

    cta: {
      bg: "#006EDD14",
      ctaMedia: ctaanipartna,
      title: "Complete Users <span class='text-[#099684]'> Profile, Followers, Business, Projects, Posts</span>  & Chat",
      text: "View user profile with followers, business, projects, and posts. Also access conversations to chat and interact with other users easily.",
    },

    similarProjects: [
      {
        id: "blink-back",
        title: "Blink Back",
        desc: "Capture, organize, and relive your favorite memories effortlessly.",
        image: "https://res.cloudinary.com/dxsr1xve0/image/upload/v1783842883/BlinkBack_rnjct0.png",
      },
      {
        id: "mecloset",
        title: "Me Closet",
        desc: "Organize outfits with a digital wardrobe and calendar.",
        image: "https://res.cloudinary.com/dxsr1xve0/image/upload/v1783842884/MeCloset_kdtflk.png",
      },
      {
        id: "gdrive",
        title: "GDrive",
        desc: "Interactive German driving test preparation with multimedia quizzes.",
        image: "https://res.cloudinary.com/dxsr1xve0/image/upload/v1783842882/Gdrive_Final_rl26qk.png",
      },
    ],
  },

  "noly": {
    color: "#2270F0",
    shadeColor1: "#2270F0",
    shadeColor2: "#8266F1",
    thumbnail: noly,
    topMedia: noly_top,
    btn1Color: "#2270F0",
    btn2Color: "#8266F1",
    btn1: "Premium Access Badge",
    btn2: "Weekly Plan Indicator",
    leftContent: [
      {
        title: "Unlimited Transcription",
        desc: "Enjoy unrestricted access to transcribe as many voice recordings as you want without any limitations or daily caps..",
      },
      {
        title: "Meeting Recorder",
        desc: "Record your official interviews, lectures, or business meetings smoothly without any time interruptions.",
      },
      {
        title: "Language Support",
        desc: "Quickly translate or transcribe your voice notes with accuracy across 100+ languages and regional dialects.",
      },
    ],
    rightContent: [
      {
        title: " File Uploads",
        desc: "Upload various document formats including standard audio files, PDFs, and high quality videos directly to the platform now.",
      },
      {
        title: " Free Trial",
        desc: "Toggle the special trial switch to instantly experience premium features for three full days without paying anything upfront.",
      },
      {
        title: "Premium Plans",
        desc: "Choose between cost effective unlimited weekly or affordable yearly subscription billing packages tailored perfectly to fit your budget",
      },
    ],
    bottom: {
      title: " Cancel Anytime",
      desc: "Enjoy complete peace of mind with the absolute freedom to cancel your ongoing premium subscription plan at any time.",
    },
    details: [
      {
        first: "image",
        image1: noly1,
        title: "Smart <span class = 'text-[#8266F1]'>Voice <br /> Recording</span> Control Page",
        desc: "The Recording Page offers real-time audio capturing, tracking timers, dynamic visual feedback, and quick action controls for discarding, starting, or saving files, helping users manage their voice notes efficiently and effortlessly.",
      },
      {
        first: "text",
        image1: noly2,
        title: "<span class = 'text-[#8266F1]'>Voice Recording</span> AI Chat Page",
        desc: "The Chat Page shows audio playback, text summaries, transcripts, and interactive AI chat tools in a simple and organized layout, helping users analyze recording content and never lose valuable insights or details.",
      },
      {
        first: "image",
        image1: noly3,
        title: "User Welcome <br /> <span class = 'text-[#8266F1]'>Authentication</span> Login Page",
        desc: "The Welcome Page shows quick email, Apple, and Google connection options in a simple and organized layout, helping users sign in effortlessly and never experience onboarding or login delays.",
      },
    ],
    cta: {
      bg: "#8B5CF614",
      ctaMedia: noly4,
      title: "Tap <span class ='text-[#8266F1]'>Record And Get <br /> Accurate</span> Word Transcripts Screen",
      text: "The platform offers seamless voice transcription management with customizable audio loyalty reward programs.",
    },
    similarProjects: [
      {
        id: "fitme",
        title: "FitMe - AI Outfit Stylist",
        desc: "AI-powered fashion styling with personalized outfit recommendations.",
        image: "https://res.cloudinary.com/dxsr1xve0/image/upload/v1783593243/Tanbnil_tlfije.png",
      },
      {
        id: "mego",
        title: "MEGO",
        desc: "Secure online marketplace with built-in rewards and benefits.",
        image: "https://res.cloudinary.com/dxsr1xve0/image/upload/v1783842885/Mego_cu6ids.png",
      },
    ],
  },

  "gdrive": {
    color: "#37A44B",
    shadeColor1: "#37A44B",
    shadeColor2: "#37A44B",
    thumbnail: GDrive_thumb,
    topMedia: GDrive_top,
    btn1Color: "#37A44B",
    btn2Color: "#37a44b",
    btn1: "Active Content Tag",
    btn2: "Category Status Indicator",
    leftContent: [
      {
        title: "Smart Search",
        desc: "Easily find specific driving topics, theory rules, or test preparation guides using the main top interactive search bar.",
      },
      {
        title: " Video Questions",
        desc: "Watch high-quality animated video clips illustrating complex traffic scenarios to accurately answer situational test questions.",
      },
      {
        title: "Picture Questions",
        desc: "Analyze visual real-world driving images, road intersections, and vehicle setup diagrams to clear your practical theory test successfully.",
      },
    ],

    rightContent: [
      {
        title: " Right Priority",
        desc: "Learn vital right-of-way regulations, overtaking rules, and roundabout navigation priorities to manage dangerous street intersections safely",
      },
      {
        title: "Traffic Signs",
        desc: "Master all critical regulatory, warning, and informational road signs with our comprehensive visual library and practice tests.",
      },
      {
        title: " Environmental Protection",
        desc: "Understand eco-friendly driving techniques, vehicle emission standards, and fuel-saving practices for your official driver license exam.",
      },
    ],

    bottom: {
      title: "Global Question Bank",
      desc: "Access over 1,100 targeted practice questions across various categories for thorough exam preparation.",
    },

    details: [
      {
        first: "image",
        image1: GDrive1,
        title: "Select App <span class = 'text-[#37A44B]'>Language </span> Screen",
        desc: "The Language Page shows global flags, localization choices, active checkmarks, and clear confirmation tools in a simple and organized layout, helping users browse content comfortably and never experience system navigation or comprehension barriers.",
      },
      {
        first: "text",
        image1: GDrive2,
        title: "Interactive Driving <br /> <span class = 'text-[#37A44B]'>Exam Question </span> Page",
        desc: "The Question Page shows localized queries, scenario illustrations, multiple-choice options, and audio playback tools in a simple and organized layout, helping users practice effectively and never miss critical driving safety rules.",
      },
      {
        first: "image",
        image1: GDrive3,
        title: "Driving <span class ='text-[#37A44B]'>Test Score</span> Result Page",
        desc: "The Score Page shows percentage metrics, passing statuses, total score metrics, and quick action buttons in a simple and organized layout, helping users celebrate success and never miss detailed performance analytics.",
      },
    ],

    cta: {
      bg: "#37A44B0F",
      ctaMedia: GDrive4,
      title: "Browse <span class = 'text-[#37A44B]'>Test Categories</span> And <br /> <span class = 'text-[#37A44B]'>Manage Account</span> Deletion",
      text: "The platform offers seamless driving test preparation with customizable driver education loyalty reward programs.",
    },

    similarProjects: [
      {
        id: "paktruck",
        title: "Pak Truck",
        desc: "Buy, sell, and promote trucks and spare parts.",
        image: "https://res.cloudinary.com/dxsr1xve0/image/upload/v1783842885/PakTRuck_gngafd.png",
      },
      {
        id: "auravpn",
        title: "Aura VPN",
        desc: "Fast, secure VPN with reliable data protection.",
        image: "https://res.cloudinary.com/dxsr1xve0/image/upload/v1784114356/Aura_VPN_Updated_v7nlme.png",
      },
      {
        id: "revealit",
        title: "Revealit",
        desc: "Scan products for ingredients, allergens, and safety insights.",
        image: "https://res.cloudinary.com/dxsr1xve0/image/upload/v1783842886/Revealt_hpnmlu.png",
      },
    ],
  },

  "paktruck": {
    color: "#19b65b",
    shadeColor1: "#19B65B",
    shadeColor2: "#19B65B",
    thumbnail: PakTruck_thumb,
    topMedia: PakTruck_top,
    btn1Color: "#19B65B",
    btn2Color: "#19B65B",
    btn1: "Active Category Filter",
    btn2: "Quick Sell Action",
    leftContent: [
      {
        title: " Smart Search",
        desc: "Easily find specific commercial vehicles, heavy machinery, or required automotive spare parts using the top interactive search bar.",
      },
      {
        title: "Vehicle Categories",
        desc: "Quickly filter available listings by choosing between trucks, machinery, transport buses, or genuine auto parts categories instantly.",
      },
      {
        title: " Subtype Selection",
        desc: "Explore specialized vehicle types like automatic, dumper, flatbed, trailer, or container carrier models with one simple tap.",
      },
    ],
    rightContent: [
      {
        title: " Marketplace Listings",
        desc: "Browse a wide selection of commercial vehicles available for purchase, complete with precise pricing and regional location.",
      },
      {
        title: "Notification Alerts",
        desc: "Stay updated on new vehicle listings, price drops, and important buyer inquiries via the top corner bell icon.",
      },
      {
        title: " Recommendation Engine",
        desc: "Discover highly relevant similar advertisements based on your recent vehicle browsing history, preferences, and current search criteria.",
      },
    ],
    bottom: {
      title: " Bottom Navigation",
      desc: "Easily manage your personal ads, post a new vehicle for sale, watch videos, or chat with buyers.",
    },
    details: [
      {
        first: "image",
        image1: PakTruck1,
        title: "Sell <span class='text-[#19b65b]'> Spare Parts <br/> Listing </span> Form ",
        desc: "The Sell Spare Parts Page offers smooth ad creation with media uploads, title inputs, category selectors, location mapping, price listing, model years, and manufacturing specifications before final publication.",
      },
      {
        first: "text",
        image1: PakTruck2,
        title: " Advanced Truck <span class='text-[#19b65b]'>  <br />Search Filter</span> Screen  ",
        desc: "The Search Filter Page offers smooth browsing with vehicle categories, location mapping, or subcategory tags, price sliders, model year ranges, registration regions, and manufacturing makes before final search submission.",
      },
      {
        first: "image",
        image1: PakTruck3,
        title: " Shop Identity<span class='text-[#19b65b]'> <br /> Verification </span> Process Screen ",
        desc: "The Verification Process Page offers smooth registration with full name inputs, email addresses, shop locations, phone numbers, identity card uploads, file attachments, and clear form submission before final confirmation.",
      },
    ],
    cta: {
      bg: "#19B65B33",
      ctaMedia: PakTruck4,
      title: "Connect Through  <span class='text-[#19b65b]'>Chat</span> And Explore <span class ='text-[#19b65b]' > Auto Store Listings </span> ",
      text: "The platform offers seamless vehicle chat management with customizable commercial loyalty reward programs.",
    },
    similarProjects: [
      {
        id: "flatty",
        title: "Flaty.pk",
        desc: "Explore, buy, and sell properties with ease.",
        image: "https://res.cloudinary.com/dxsr1xve0/image/upload/v1783842884/Flaty.pk_r8sxhu.png",
      },
    ],
  },

  "auravpn": {
    color: "#11054D",
    shadeColor1: "#11054D",
    shadeColor2: "#0069FF",
    thumbnail: auravpn,
    topMedia: topauravpn,
    btn1Color: "#11054D",
    btn2Color: "#0069FF",
    btn1: "Region Selection",
    btn2: "Connectivity",
    leftContent: [
      {
        title: "Secure & Private Browsing Experience",
        desc: "Browse the internet safely with strong encryption that protects your data and keeps your online activity private.",
      },
      {
        title: "Fast Global Server Connectivity",
        desc: " Connect to multiple high-speed servers worldwide for smooth, stable, and fast internet access without interruptions or buffering issues.",
      },
      {
        title: "One-Tap Quick Connection Access",
        desc: " Easily connect to a secure VPN server instantly with a single tap for fast and hassle-free access anytime.",
      },
    ],
    rightContent: [
      {
        title: "Smart Server Region Selection",
        desc: " Choose from different country servers based on your needs, including both free and premium options for better speed and access.",
      },
      {
        title: "Real-Time Secure Connection Status",
        desc: " View your active connection status with selected country details and live timer showing how long the VPN has been running.",
      },
      {
        title: "Internet Speed & Connection Test",
        desc: " Check your VPN performance with speed tests showing download, upload, IP details, signal strength, and connection stability.",
      },
    ],

    bottom: {
      title: "Simple & User-Friendly Interface",
      desc: "Enjoy a modern, easy-to-use dashboard for smooth navigation and effortless VPN control.",
    },

    details: [
      {
        first: "image",
        image1: auravpn1,
        title: "Secure <span class='text-[#3F42FF]'>VPN Connection Establishing </span> Now",
        desc: "A secure and encrypted VPN connection is being established to protect your data and privacy. Please wait while the system connects you to the best available server for safe and stable browsing.",
      },
      {
        first: "text",
        image1: auravpn2,
        title: "VPN <span class='text-[#3F42FF]'>Speed Test & Performance</span> Check",
        desc: "Check your VPN performance with a quick speed test showing download, upload, IP details, and connection strength. It helps you understand your internet speed and overall connection quality while using the VPN.",
      },
      {
        first: "image",
        image1: auravpn3,
        title: "VPN <span class='text-[#3F42FF]'> Speed Test Summary</span> Report",
        desc: "View complete speed test summary including connection duration, IP address, signal strength, upload rate, and download rate. It helps you clearly analyze your VPN performance and connection quality.",
      },
    ],

    cta: {
      bg: "#3F42FF14",
      ctaMedia: ctaauravpn,
      title: "Free & Premium <span class='text-[#3F42FF]'> Locations with Subscription and Reward</span> System",
      text: "Browse free and premium locations or unlock premium access through subscription or rewards by watching ads for 30 minutes.",
    },

    similarProjects: [
      {
        id: "gbc",
        title: "GBC",
        desc: "Connecting learners with mentors through interactive live learning.",
        image: "https://res.cloudinary.com/dxsr1xve0/image/upload/v1784114356/GBC_qyt1gs.png",
      },
      {
        id: "afroneta",
        title: "Afroneta",
        desc: "All-in-one platform for content, payments, and community management.",
        image: "https://res.cloudinary.com/dxsr1xve0/image/upload/v1783842887/AfroNeta_cpswek.png",
      },
      {
        id: "on-the-dot",
        title: "Service Booking",
        desc: "Seamless service booking with efficient business management.",
        image: "https://res.cloudinary.com/dxsr1xve0/image/upload/v1783842888/Service_Booking_App_zi2i3n.png",
      },
    ],
  },

  "revealit": {
    color: "#15AF4F",
    shadeColor1: "#15AF4F",
    shadeColor2: "#15AF4F",
    thumbnail: revealit_thumb,
    topMedia: revealit_top,
    btn1Color: "#15AF4F",
    btn2Color: "#15AF4F",
    btn1: "Reveal Now",
    btn2: "Stay Anonymous",
    leftContent: [
      {
        title: "Anonymous Reveal System",
        desc: "Send and receive anonymous messages or reveals from others while keeping your identity completely hidden and secure.",
      },
      {
        title: "Mystery Inbox",
        desc: "Receive hidden messages and surprises in your inbox from people around you without knowing who sent them.",
      },
      {
        title: "Profile Discovery",
        desc: "Discover and connect with new people through an engaging profile browsing experience built for fun interaction.",
      },
    ],
    rightContent: [
      {
        title: "Reveal Reactions",
        desc: "React to received reveals with emotions and responses to keep the conversation engaging and interactive at all times.",
      },
      {
        title: "Hints & Clues System",
        desc: "Get subtle hints about who sent you a reveal and try to guess the sender for a fun and exciting experience.",
      },
      {
        title: "Safe & Secure Platform",
        desc: "All interactions are monitored and protected ensuring a safe, respectful, and enjoyable experience for every user.",
      },
    ],
    bottom: {
      title: "Fun & Engaging Experience",
      desc: "Enjoy a unique social experience where mystery, curiosity, and connection come together in one exciting platform.",
    },
    details: [
      {
        first: "image",
        image1: revealit1,
        title: "Send <span class='text-[#15AF4F]'>Anonymous Reveals</span> & Messages",
        desc: "Send anonymous messages and reveals to anyone on the platform while keeping your identity fully hidden for a fun and mysterious interaction experience.",
      },
      {
        first: "text",
        image1: revealit2,
        title: "Receive <span class='text-[#15AF4F]'>Hints & Guess</span> the Sender",
        desc: "Get exciting hints and clues about who sent you a reveal and try to guess the mystery sender for a thrilling and engaging social experience.",
      },
      {
        first: "image",
        image1: revealit3,
        title: "React & <span class='text-[#15AF4F]'>Respond to</span> Your Reveals",
        desc: "React to received reveals with emotions, replies, and responses to keep the conversation going and make every interaction more fun and meaningful.",
      },
    ],
    cta: {
      bg: "#15AF4F14",
      ctaMedia: revealit4,
      title: "Anonymous Reveals with <span class='text-[#15AF4F]'>Hints, Reactions & Mystery</span> Connections",
      text: "Send anonymous reveals, get exciting hints about senders, and react to messages for a fun and unique social experience.",
    },
    similarProjects: [
      {
        id: "noly",
        title: "Noly",
        desc: "Convert audio into accurate transcripts and concise summaries.",
        image: "https://res.cloudinary.com/dxsr1xve0/image/upload/v1784029767/Noly_nbyhyw.png",
      },
    ],
  },

  "zipzap": {
    color: "#00B8D9",
    shadeColor: "#00B8D94D",
    thumbnail: zipzap,
    topMedia: zipzap,
    btn1: "Instant Chat",
    btn2: "Easy Connect",
    leftContent: [
      {
        title: "Instant Messaging",
        desc: "Send and receive messages instantly with a fast and smooth chat interface designed for seamless real-time communication.",
      },
      {
        title: "Voice & Video Calls",
        desc: "Make high-quality voice and video calls with friends and family anytime using a stable and reliable connection.",
      },
      {
        title: "Group Chats",
        desc: "Create group conversations with multiple people to stay connected, share updates, and collaborate easily in one place.",
      },
    ],
    rightContent: [
      {
        title: "Media Sharing",
        desc: "Share photos, videos, documents, and files instantly within chats for quick and easy content exchange anytime.",
      },
      {
        title: "Status Updates",
        desc: "Post status updates to share moments with your contacts and stay updated on what others are sharing.",
      },
      {
        title: "End-to-End Encryption",
        desc: "All messages and calls are fully encrypted ensuring your conversations remain private, secure, and protected at all times.",
      },
    ],
    bottom: {
      title: "Simple & Fast Communication",
      desc: "Enjoy a clean and intuitive chat experience built for speed, simplicity, and smooth everyday communication.",
    },
    details: [
      {
        first: "image",
        image1: zipzap,
        title: "Instant <span class='text-[#00B8D9]'>Messaging & Chat</span> Experience",
        desc: "Send and receive messages in real time with a smooth and fast chat interface designed for simple and efficient everyday communication.",
      },
      {
        first: "text",
        image1: zipzap,
        title: "Voice & <span class='text-[#00B8D9]'>Video Calls</span> Feature",
        desc: "Connect with friends and family through high-quality voice and video calls that provide a stable and clear communication experience anytime.",
      },
      {
        first: "image",
        image1: zipzap,
        title: "Media <span class='text-[#00B8D9]'>Sharing & File</span> Transfer",
        desc: "Easily share photos, videos, documents, and other files directly within your chats for quick and convenient content exchange with anyone.",
      },
    ],
    cta: {
      bg: "#00B8D914",
      ctaMedia: zipzap,
      title: "Fast Messaging with <span class='text-[#00B8D9]'>Calls, Media Sharing & Secure</span> Communication",
      text: "Chat instantly, make voice and video calls, share media, and enjoy fully encrypted secure communication all in one app.",
    },
    similarProjects: [],
  },

  "safe-choice": {
    color: "#4CAF50",
    shadeColor1: "#4CAF50",
    shadeColor2: "#4CAF50",
    thumbnail: SafeChoice_thumb,
    topMedia: SafeChoice_top,
    btn1Color: "#4CAF50",
    btn2Color: "#4CAF50",
    btn1: "Smart Search",
    btn2: "Health Insights",

    leftContent: [
      {
        title: "Product Search",
        desc: "Easily search for your daily grocery items, snacks, or specific health products directly using the top interactive search bar.",
      },
      {
        title: "Protein Bars",
        desc: "Browse a curated marketplace selection of premium nutritious bars complete with precise ingredient checks and safe brand names.",
      },
      {
        title: "Green Indicators",
        desc: "View intuitive green safety indicator icons highlighted on every item card to instantly identify healthy and safe products.",
      },
    ],

    rightContent: [
      {
        title: "Top Categories",
        desc: "Quickly filter alternative items by choosing between specialized protein bars, organic powders, healthy snacks, or pure bottled water.",
      },
      {
        title: "Protein Powders",
        desc: "Discover clean plant-based or organic hemp formulas safely categorized to boost your active lifestyle and daily fitness routine.",
      },
      {
        title: "Barcode Scanner",
        desc: "Tap the prominent center floating action button to instantly scan any product barcode using your mobile phone camera.",
      },
    ],

    bottom: {
      title: "Bottom Navigation",
      desc: "Track your previous scanning history, check personalized profile settings, or start direct chats seamlessly using these smart icons.",
    },

    details: [
      {
        first: "image",
        image1: SafeChoice1,
        title: "<span class='text-[#4CAF50]'> Detailed Product  <br /></span> Ingredient Analysis Page",
        desc: "The Product Page shows health scores, ingredient breakdowns, processing levels, and nutritional warnings in a clear and organized layout, helping users identify harmful substances and make healthy grocery shopping choices without any confusion.",
      },
      {
        first: "text",
        image1: SafeChoice2,
        title: "Premium <span class='text-[#4CAF50]'> Free Trial <br /> Subscription</span> Page",
        desc: "The Trial Page shows billing timelines, reminder alerts, package selections, and active payment buttons in a simple and organized layout, helping users understand premium plans and never experience unexpected subscription charges or hidden fees.",
      },
      {
        first: "image",
        image1: SafeChoice3,
        title: "Interactive Product <br /> <span class='text-[#4CAF50]'>Barcode Scanner</span> Page",
        desc: "The Scanner Page shows camera viewfinders, mode selectors, flash toggles, and live pop-up results in a simple and organized layout, helping users analyze ingredient items and never buy unhealthy grocery products or dangerous snacks.",
      },
    ],

    cta: {
      bg: "#4CAF5014",
      ctaMedia: SafeChoice4,
      title: "Analyze Product <span class='text-[#4CAF50]'>Ingredients </span> And <br /> View Better <span class='text-[#4CAF50]'> Recommendations </span",
      text: "Discover healthy alternative grocery items with smart ingredient ratings.",
    },

    similarProjects: [
      {
        id: "gbc",
        title: "GBC",
        desc: "Connecting learners with mentors through interactive live learning.",
        image: "https://res.cloudinary.com/dxsr1xve0/image/upload/v1784114356/GBC_qyt1gs.png",
      },
      {
        id: "afroneta",
        title: "Afroneta",
        desc: "All-in-one platform for content, payments, and community management.",
        image: "https://res.cloudinary.com/dxsr1xve0/image/upload/v1783842887/AfroNeta_cpswek.png",
      },
      {
        id: "on-the-dot",
        title: "Service Booking",
        desc: "Seamless service booking with efficient business management.",
        image: "https://res.cloudinary.com/dxsr1xve0/image/upload/v1783842888/Service_Booking_App_zi2i3n.png",
      },
    ],
  },

  // "yazboz": {
  //   color: "#FF6D00",
  //   shadeColor1: "#FF6D00",
  //   shadeColor2: "#FF6D00",
  //   thumbnail: Yazboz_thumb,
  //   topMedia: Yazboz_top,
  //   btn1Color: "#FF6D00",
  //   btn2Color: "#FF6D00",
  //   btn1: "Track Live Scores",
  //   btn2: "Create New Table",

  //   leftContent: [
  //     {
  //       title: "Score Tracking",
  //       desc: "Easily track your Okey board game scores and match statistics digitally without using traditional pen and paper.",
  //     },
  //     {
  //       title: "Total Games",
  //       desc: "Monitor the total number of played games efficiently on your dashboard to review your complete gaming history.",
  //     },
  //     {
  //       title: "Active Matches",
  //       desc: "View your currently ongoing live matches instantly to resume playing and updating scores without losing any progress.",
  //     },
  //   ],

  //   rightContent: [
  //     {
  //       title: "Completed Games",
  //       desc: "Check your successfully finished tournament history cards to evaluate previous match results and final winning score summaries.",
  //     },
  //     {
  //       title: "Quick Actions",
  //       desc: "Launch a fresh game session rapidly using the prominent interactive bright orange action buttons on your screen.",
  //     },
  //     {
  //       title: "App Settings",
  //       desc: "Configure your personal profile preferences, game configurations, or dashboard display options easily using the top gear icon.",
  //     },
  //   ],

  //   bottom: {
  //     title: "Navigation Bar",
  //     desc: "Switch smoothly between your personalized home dashboard view and detailed game list metrics using the bottom panel.",
  //   },

  //   details: [
  //     {
  //       first: "image",
  //       image1: Yazboz1,
  //       title: "<span class='text-[#FF6D00]'>Create New </span> Okey  <br />Table Screen",
  //       desc: "The Creation Page shows game names, type selectors, round pickers, and multi-step progress indicators in a simple and organized layout, helping users configure match setups and never lose track of custom table details.",
  //     },
  //     {
  //       first: "text",
  //       image1: Yazboz2,
  //       title: "Configure Okey <br /><span class='text-[#FF6D00]'>Game Players</span> Screen",
  //       desc: "The Team Page shows team layouts, player names, badge tags, and active step trackers in a simple and organized layout, helping users assign participant spots and never lose valuable game configuration details.",
  //     },
  //     {
  //       first: "image",
  //       image1: Yazboz3,
  //       title: "Match <span class='text-[#FF6D00]'> Score Input <br /></span> Dashboard Screen",
  //       desc: "The Score Page shows player avatars, value adjusters, total sums, and active finish buttons in a simple and organized layout, helping users log match points and never lose valuable game progression details.",
  //     },
  //   ],

  //   cta: {
  //     bg: "#FF6D0014",
  //     ctaMedia: Yazboz4,
  //     title: "Manage <span class='text-[#FF6D00]'> App Customizations <br /> </span> And Track Match Statistics",
  //     text: "Configure personal display preferences and view final gaming session achievements effortlessly.",
  //   },

  //   similarProjects: [
  //     {
  //       id: "safe-choice",
  //       title: "SafeChoice",
  //       desc: "Scan products for health scores, allergen alerts, and smarter choices.",
  //       image: "https://res.cloudinary.com/dxsr1xve0/image/upload/v1783842886/SafeChoice_nk72vp.png",
  //     },
  //     {
  //       id: "mb-travel",
  //       title: "MB Travel",
  //       desc: "Digital visa applications with secure document tracking.",
  //       image: "https://res.cloudinary.com/dxsr1xve0/image/upload/v1783669931/MB_Travel_Tanbnil_kyswqf.png",
  //     },
  //     {
  //       id: "on-the-dot",
  //       title: "Service Booking",
  //       desc: "Seamless service booking with efficient business management.",
  //       image: "https://res.cloudinary.com/dxsr1xve0/image/upload/v1783842888/Service_Booking_App_zi2i3n.png",
  //     },
  //   ],
  // },

  // FitME
  "fitme": {
    tag: "app",

    color: "#FF4081",
    shadeColor: "#FF408166",

    thumbnail: FitMe_thumb,
    topMedia: FitMe_top,

    heroTag: "AI Wardrobe Stylist",

    title: "Smart <span class='text-[#FF4081]'>AI Outfit Stylist</span> App",

    desc: "Discover intelligent outfit recommendations with an AI-powered wardrobe app designed to curate, plan, and style your daily looks effortlessly.",

    leftContent: [
      {
        title: "Smart Curation",
        desc: "Explore personalized wardrobe suggestions like casual, formal, seasonal, work, or party wear clothing trends with one simple tap.",
      },
      {
        title: "Style Planner",
        desc: "Schedule your upcoming weekly outfits like corporate, wedding, holiday, sports, or evening event styles with one simple tap.",
      },
      {
        title: "Digital Wardrobe",
        desc: "Save your favorite curated combinations like jackets, trousers, boots, shirts, or trending accessories with one simple tap.",
      },
    ],

    rightContent: [
      {
        title: "Weather Adaptation",
        desc: "Discover relevant climate attire choices like winter, summer, rainy, autumn, or spring clothing recommendations with one simple tap.",
      },
      {
        title: "Automated Picks",
        desc: "Generate intelligent daily matching suggestions like modern, vintage, minimal, vibrant, or professional fashion layouts with one simple tap.",
      },
      {
        title: "History Tracker",
        desc: "Review your previously selected combinations like traditional, luxury, streetwear, athletic, or business clothing histories with one simple tap.",
      },
    ],

    bottom: {
      title: "Cart Integration",
      desc: "Purchase highly recommended matching items like footwear, outerwear, garments, jewelry, or essential lifestyle products with one simple tap.",
    },

    details: [
      {
        first: "image",
        image1: FitMe_1,
        title: "Automated <span class='text-[#FF4081]'>Wardrobe Item Summary</span> Screen",
        desc: "The Summary Page shows item inputs, color palettes, apparel categories, and occasion tags in a simple and organized layout, helping users organize clothing items and never pick mismatched fashion products or wrong styling combinations.",
      },
      {
        first: "text",
        image1: FitMe_2,
        title: "Interactive <span class='text-[#FF4081]'>Clothing Customization</span> Selection Screen",
        desc: "The Selection Page shows material fabric, occasion filters, type categories, and customized color dots in a simple and organized layout, helping users catalog wardrobe items and never select mismatched apparel products or inaccurate styling options.",
      },
      {
        first: "image",
        image1: FitMe_3,
        title: "Interactive <span class='text-[#FF4081]'>Wardrobe Camera</span> Scanner Screen",
        desc: "The Scanner Page shows camera viewfinders, aspect ratios, flash toggles, and live gallery previews in a simple and organized layout, helping users scan apparel items and never upload blurry clothing products or distorted lifestyle snaps.",
      },
    ],

    cta: {
      bg: "#FF40811F",
      ctaMedia: FitMe_4,
      title: "Plan Your <span class='text-[#FF4081]'>Weekly Outfits and AI</span> Generated Looks",
      text: "This system offers real-time outfit planning and style selection to improve experience and wardrobe quality.",
    },

    similarProjects: [
      {
        id: "mego",
        title: "MEGO",
        desc: "Secure online marketplace with built-in rewards and benefits.",
        image: "https://res.cloudinary.com/dxsr1xve0/image/upload/v1783842885/Mego_cu6ids.png",
      },
      {
        id: "noly",
        title: "Noly",
        desc: "Convert audio into accurate transcripts and concise summaries.",
        image: "https://res.cloudinary.com/dxsr1xve0/image/upload/v1784029767/Noly_nbyhyw.png",
      },
    ],
  },

  // MEGO
  "mego": {
    tag: "app",

    color: "#FFDE59",
    shadeColor1: "#2874F0 ",
    shadeColor2: "#FFDE59",
    btn1Color: "#FFDE59",
    btn2Color: "#2874F0",
    btn1: "We Offer",
    btn2: "Top Phone Ads",
    thumbnail: mego_thhumb,
    topMedia: mego_top,

    heroTag: "Classified Marketplace",

    title: "Buy & Sell <span class='text-[#FF6F00]'>Verified Items</span> Instantly",

    desc: "Explore a seamless classified marketplace to discover smartphones, automobiles, and properties while connecting directly with verified regional sellers.",

    leftContent: [
      {
        title: "Smart Search",
        desc: "Locate desired items quickly by entering specific keywords alongside selecting your preferred regional location filters seamlessly.",
      },
      {
        title: "Diverse Categories",
        desc: "Browse verified marketplace listings instantly by choosing between mobile smartphones, premium automobiles, or commercial properties easily.",
      },
      {
        title: "Promotional Banners",
        desc: "Discover exclusive discounted deals and highlighted automotive advertisements displayed directly onto your interactive home dashboard screen.",
      },
    ],

    rightContent: [
      {
        title: "Instant Selling",
        desc: "Upload your personal classified advertisements effortlessly by pressing the prominent central action button to engage buyers.",
      },
      {
        title: "Direct Chat",
        desc: "Connect securely with verified regional sellers using our intuitive live messaging features to negotiate prices instantly.",
      },
      {
        title: "Reward Points",
        desc: "Monitor your accumulated virtual profile coins displayed at the top corner to unlock premium application bonuses.",
      },
    ],

    bottom: {
      title: "Profile Management",
      desc: "Oversee your individual account settings, current active listings, and security preferences using the structured footer layout.",
    },

    details: [
      {
        first: "image",
        image1: mego_1,
        title: "Personalized <span class='text-[#FFDE59]'>Marketplace Saved Ads</span> Screen",
        desc: "The Saved Page shows bookmarked products, favorite items, price tags, and clear item images in a clean and structured dashboard layout, helping users monitor preferred listings and easily secure highly discounted regional deals or premium properties.",
      },
      {
        first: "text",
        image1: mego_2,
        title: "Real Time <span class='text-[#2874F0]'>Marketplace Notifications</span> Screen",
        desc: "The Notifications Page shows payment receipts, review statuses, account updates, and live alert badges in a clean and minimal interface layout, helping users track advertisement approvals and never miss critical transaction confirmations or important marketplace updates.",
      },
      {
        first: "image",
        image1: mego_3,
        title: "Comprehensive <span class='text-[#FFDE59]'>User Account Settings</span> Screen",
        desc: "The Account Page shows profile settings, bookmarked advertisements, transaction history, and support links in a clean and organized menu layout, helping users manage personal details and never lose track of active classified orders or critical profile security configurations.",
      },
    ],

    cta: {
      bg: "#2874F033",
      ctaMedia: mego_4,
      title: "Buy and Sell <span class='text-[#FFDE59]'>Verified Items on Our</span> Marketplace",
      text: "This platform offers real-time seller chats and product views to improve transparency and deal quality.",
    },

    similarProjects: [
      {
        id: "fitme",
        title: "FitMe - AI Outfit Stylist",
        desc: "AI-powered fashion styling with personalized outfit recommendations.",
        image: "https://res.cloudinary.com/dxsr1xve0/image/upload/v1783593243/Tanbnil_tlfije.png",
      },
      {
        id: "mb-travel",
        title: "MB Travel",
        desc: "Digital visa applications with secure document tracking.",
        image: "https://res.cloudinary.com/dxsr1xve0/image/upload/v1783669931/MB_Travel_Tanbnil_kyswqf.png",
      },
    ],
  },

  // MB Travel
  "mb-travel": {
    tag: "app",

    color: "#1A73E8",
    shadeColor: "#1A73E866",
    shadeColor1: "#0F77DC",
    shadeColor2: "#0F77DC",
    btn1Color: "#0F77DC",
    btn2Color: "#0F77DC",
    btn1: "Visa Application",
    btn2: "Apply For Visa",
    thumbnail: MbTravel_thumb,
    topMedia: MbTravel_top,

    heroTag: "Visa Application Platform",

    title: "Smart <span class='text-[#1A73E8]'>Visa & Immigration</span> Platform",

    desc: "Complete tourist, business, student, or transit visa applications effortlessly with secure document uploads, real-time tracking, and expert legal guidance.",

    leftContent: [
      {
        title: "Digital Applications",
        desc: "Complete your official immigration forms like tourist, business, student, or transit visas easily with one simple tap.",
      },
      {
        title: "Document Upload",
        desc: "Submit required personal papers like identity cards, passports, photographs, or official invitation documents with one simple tap.",
      },
      {
        title: "Status Tracking",
        desc: "Monitor your active application updates like pending, approved, verified, rejected, or processing stages with one simple tap.",
      },
    ],

    rightContent: [
      {
        title: "Secure Payments",
        desc: "Process urgent government processing fees like processing, premium, embassy, or biometric transaction costs with one simple tap.",
      },
      {
        title: "Expert Guidance",
        desc: "Access certified legal advice files like instructions, checklists, templates, handbooks, or compliance guidelines with one simple tap.",
      },
      {
        title: "Instant Notifications",
        desc: "Receive critical verification update alerts like interviews, deadlines, approvals, appointments, or courier dispatches with one simple tap.",
      },
    ],

    bottom: {
      title: "Profile Management",
      desc: "Save multiple traveler credentials like names, passport details, addresses, histories, or contact numbers with one simple tap.",
    },

    details: [
      {
        first: "image",
        image1: MbTravel1,
        title: "Personalized <span class='text-[#1A73E8]'>Immigration Travel Dashboard</span> Screen",
        desc: "The Dashboard Page shows travel categories, destination filters, active applications, and current review statuses in a clean and organized interface layout, helping users monitor immigration progress and never miss important document deadlines or critical embassy appointments.",
      },
      {
        first: "text",
        image1: MbTravel2,
        title: "Interactive <span class='text-[#1A73E8]'>Visa Purpose Selection</span> Screen",
        desc: "The Purpose Page shows travel options, student categories, work permits, and investment selection cards in a clean and organized layout, helping users identify immigration pathways and never submit incorrect application forms or unapproved documentation types.",
      },
      {
        first: "image",
        image1: MbTravel3,
        title: "Comprehensive <span class='text-[#1A73E8]'>Active Visa Tracking</span> Screen",
        desc: "The Tracker Page shows active timelines, document verifications, payment confirmations, and final decision stages in a clean and structured list layout, helping users monitor multi-country immigration progress and never miss important verification milestones or critical process updates.",
      },
    ],

    cta: {
      bg: "#1A73E81F",
      ctaMedia: MbTravel4,
      title: "Track Your <span class='text-[#1A73E8]'>Global Visa Applications</span> and Documents Seamlessly",
      text: "Our platform offers advanced filter systems and status tracking to improve transparency and upload quality.",
    },

    similarProjects: [
      {
        id: "mego",
        title: "MEGO",
        desc: "Secure online marketplace with built-in rewards and benefits.",
        image: "https://res.cloudinary.com/dxsr1xve0/image/upload/v1783842885/Mego_cu6ids.png",
      },
      {
        id: "fitme",
        title: "FitMe - AI Outfit Stylist",
        desc: "AI-powered fashion styling with personalized outfit recommendations.",
        image: "https://res.cloudinary.com/dxsr1xve0/image/upload/v1783593243/Tanbnil_tlfije.png",
      },
      {
        id: "safe-choice",
        title: "SafeChoice",
        desc: "Scan products for health scores, allergen alerts, and smarter choices.",
        image: "https://res.cloudinary.com/dxsr1xve0/image/upload/v1783842886/SafeChoice_nk72vp.png",
      },
    ],
  },





    // web mockups

   // UBK Towing
   "ubk-towing": {
  tag: 'web',
  color: '',
  shadeColor1: '#F6902199',
  shadeColor2: '#3091C966',
 
  thumbnail: UbkTowing_thumb,
  topMedia: UbkTowing_top,

  heroTag: 'Service Management',
  title: "Professional <span class='text-[#333]'>Towing Service</span> Platform",
  desc: 'Request reliable towing assistance, manage roadside services, and track support requests through a fast and user-friendly dashboard.',

  leftContent: [
    {
      title: 'Monitor Meter Readings',
      desc: 'Track real-time kilometer data graphs tailored perfectly to check asset usage.',
    },
    {
      title: 'Manage Dashboard Widgets',
      desc: 'Reorganize visible operational metrics panels tailored perfectly to customize active views.',
    },
  ],

  rightContent: [
    {
      title: 'Track Vehicle Locations',
      desc: 'Review active service centers information tailored perfectly to locate enterprise trucks.',
    },
    {
      title: ' Monitor Vehicle Assignments',
      desc: 'Check assigned fleet status numbers tailored perfectly to optimize daily dispatch.',
    },
  ],

  bottom: {
    title: 'Review Trip Inspections',
    desc: 'Navigate through vehicle safety logs tailored perfectly to meet corporate requirements.',
  },

  details: [
    {
      first: 'text',
      image1: UbkTowing1,
      title: "Smart <span class = 'text-[#2563F4]'>Inspection Item Failure</span>  Management",
      desc: 'Track, review, and manage vehicle inspection item failures through an organized interface that allows admin users to filter submission details quickly while resolving issues efficiently.',
    },
    {
      first: 'image',
      image1: UbkTowing2,
      title: "<span class = 'text-[#2563F4]'>Real-Time Vehicle Status</span> <br /> Tracking",
      desc: 'Track, monitor, and manage active fleet units through an organized interface that allows users to view operational updates quickly while helping operators identify maintenance needs efficiently.',
    },
    {
      first: 'text',
      image1: UbkTowing3,
      title: "Complete <span class = 'text-[#2563F4]'>Pre-Trip Safety</span> Inspection",
      desc: 'Monitor vehicle details and complete all mandatory inspection items instantly. Analyze interactive camera upload fields to optimize your entire operational safety system.',
    },
  ],

 similarProjects: [
    {
        id: "developers-door",
        title: "Developers Door",
        desc: "A modern platform for developers to learn, showcase projects, and explore careers.",
        image: 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1782816121/Tanbnil_qtlfyd.png',
    },
    {
        id: "visaera",
        title: "Visaera Worldwide",
        desc: "Access global visa guidance, applications, and travel requirements in one platform.",
        image: 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1782816205/Tanbnil_idqvvd.png',
    },
    {
        id: "pak-truck",
        title: "Pak Truck",
        desc: "A responsive logistics website showcasing trucking services, fleet solutions, and business operations.",
        image: 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1782816195/Tanbnil_uurjnc.png',
    },
],
},

// Supply King 
"supply-king": {
    tag: 'web',
    color: '#016533',
    shadeColor1: '#EF861180',
    shadeColor2: '#BC1E1366',

    thumbnail: SupplyKing_thumb,
    topMedia: SupplyKing_top,

    heroTag: 'Wholesale Platform',

    title: "Smart <span class='text-[#333]'>Supply Chain</span> Management",

    desc: 'Simplify wholesale purchasing, inventory management, and order fulfillment through a powerful and intuitive business platform.',

    leftContent: [
        {
            title: 'Browse Industry Standards',
            desc: 'Explore a curated selection of standard commercial glassware designed to meet high-quality hospitality requirements.',
        },
        {
            title: 'Adjust Item Quantities',
            desc: 'Easily increase or decrease the order volume for specific products using intuitive quantity selectors.',
        },
    ],

    rightContent: [
        {
            title: 'View All Products',
            desc: 'Expand your current view to explore the full catalog of available inventory and supplies',
        },
        {
            title: 'Shop Top Categories',
            desc: 'Navigate through popular product segments below to quickly find specific catering and packaging essentials.',
        },
    ],

    bottom: {
        title: 'Streamline Commercial Ordering',
        desc: 'Place bulk orders efficiently through a clean interface built specifically for seamless business procurement.',
    },

    details: [
        {
            first: 'text',
            image1: SupplyKing1,
            title: "Shop Premium Business <br /> Supplies",
            desc: 'Browse our top commercial categories and subscribe to get the latest updates on high-quality restaurant essentials.',
        },
        {
            first: 'image',
            image1: SupplyKing2,
            title: "Browse Complete Product Catalog",
            desc: 'Explore our extensive range of restaurant essentials, where you can easily filter, sort, and adjust order quantities directly from the product grid to streamline your business procurement process.',
        },
        {
            first: 'text',
            image1: SupplyKing3,
            title: "Enter Your Account Registration Details",
            desc: 'Fill in your primary contact information and account credentials to easily create your secure business profile.',
        },
    ],

    similarProjects: [
    {
        id: 'pak-truck',
        title: 'Pak Truck',
        desc: "A responsive logistics website for trucking and fleet solutions.",
        image: 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1782816195/Tanbnil_uurjnc.png',
    },
    {
        id: 'ubk-towing',
        title: 'UBK Towing',
        desc: "Streamline transportation with vehicle management and inspections.",
        image: 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1782816201/Tanbnill_lb3ckm.png',
    },
    {
        id: 'earning-dashboard',
        title: 'Earning Dashboard',
        desc: "Monitor revenue and financial performance in real-time.",
        image: 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1782816167/Add_main_Dashboard_-_Tanbnil_p7awef.png',
    },
]
},

// We Scale Web 

"we-scale-hq": {
    tag: 'web',
    color: '#016533',
    shadeColor1: '#443FFF99',
    shadeColor2: '#908DFF99',

    thumbnail: WeScale_thumb,
    topMedia: WeScale_top,

    heroTag: 'Sales Growth Platform',

    title: "Accelerate <span class='text-[#333]'>Business Growth</span>",

    desc: 'Empower your sales team with powerful tools, performance insights, and streamlined workflows designed to scale your business faster.',

    leftContent: [
        {
            title: 'Scale Revenue Growth',
            desc: 'Our specialized systems help businesses scale their overall revenue up to three times within a single year.',
        },
        {
            title: 'Audit Revenue Systems',
            desc: 'Identify hidden leaks in your sales pipeline, current offers, and active automation setup to fix technical guesswork.',
        },
    ],

    rightContent: [
        {
            title: 'Analyze Sales Pipelines',
            desc: 'Get a complete pipeline analysis and offer structure evaluation to understand your primary workflow gaps clearly.',
        },
        {
            title: 'Optimize Your Offers',
            desc: 'Restructure your pricing and overall sales process to ensure your incoming business leads convert predictably.',
        },
    ],

    bottom: {
        title: 'Implement Actionable Roadmaps',
        desc: 'Receive an actionable improvement roadmap designed to execute end-to-end pipeline design and conversion rate optimization.',
    },

    details: [
        {
            first: 'text',
            image1: WeScale1,
            title: "Scale <span class = 'text-[#2563F4]'>Your Business Revenue</span>  Predictably",
            desc: 'Combine expertise in sales, marketing, and operations to diagnose system leaks and design strategic high-converting offers that predictably grow your revenue end to end.',
        },
        {
            first: 'image',
            image1: WeScale2,
            title: "Track <span class = 'text-[#2563F4]'>Successful Client Case</span> Studies",
            desc: 'Review real-world business growth metrics, outcomes, and key performance results across various global industries to replicate high-yielding revenue engines.',
        },
        {
            first: 'text',
            image1: WeScale3,
            title: "Fill <span class = 'text-[#2563F4]'>Out The Registration</span> Form",
            desc: 'Submit your business details and biggest sales challenges to claim your free operational audit and bonus strategy guide.',
        },
    ],

   similarProjects: [
    {
        id: 'earning-dashboard',
        title: 'Earning Dashboard',
        desc: "Monitor revenue and financial performance in real-time.",
        image: 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1782816167/Add_main_Dashboard_-_Tanbnil_p7awef.png',
    },
    {
        id: 'supply-king',
        title: 'Supply King',
        desc: "Simplify bulk ordering, supply management, and order tracking.",
        image: 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1782816196/Supply_king_kriepq.png',
    },
    {
        id: 'flaty-web',
        title: 'Flaty.pk',
        desc: "Explore, buy, and sell properties with trusted listings and secure transactions.",
        image: 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1782816184/Tanbnil_yujxor.png',
    },
]
},

// flatty Web 
"flaty-web": {
    tag: 'web',
    color: '#016533',
    shadeColor1: '#FFCB4D99',
    shadeColor2: '#FC9B0466',

    thumbnail: flattyweb_thumb,
    topMedia: flattyweb_top,

    heroTag: 'Real Estate Platform',

    title: "Modern <span class='text-[#333]'>Property Management</span>",

    desc: 'Discover, buy, and sell properties through a modern real estate platform designed for seamless browsing and effortless transactions.',

    leftContent: [
        {
            title: 'Browse Popular Properties',
            desc: 'Navigate through premium real estate listings tailored perfectly to meet your operational requirements.',
        },
        {
            title: 'Rent Ideal Homes',
            desc: 'Navigate through available rental housing options tailored perfectly to meet your operational requirements.',
        },
    ],

    rightContent: [
        {
            title: 'Buy Verified Houses',
            desc: 'Navigate through secure property purchase deals tailored perfectly to meet your operational requirements.',
        },
        {
            title: 'Check Sponsored Listings',
            desc: 'Navigate through featured premium property ads tailored perfectly to meet your operational requirements.',
        },
    ],

    bottom: {
        title: 'Explore Apartment Options',
        desc: 'Navigate through specific residential sub-categories tailored perfectly to meet your operational requirements.',
    },

    details: [
        {
            first: 'text',
            image1: flattyweb1,
            title: "Manage  <span class = 'text-[#016533]'>Your Active User</span> <br /> Chats",
            desc: 'Monitor active user chat histories and total platform messages instantly. Analyze interactive active contact lists to optimize your entire communication system.',
        },
        {
            first: 'image',
            image1: flattyweb2,
            title: " Manage <span class = 'text-[#016533]'>Your Booked Client</span>  Appointments ",
            desc: 'Monitor active calendar booking summaries and total platform appointments instantly. Analyze interactive card distribution lists to optimize your entire operational system. ',
        },
        {
            first: 'text',
            image1: flattyweb3,
            title: "Manage <span class = 'text-[#016533]'>Your Active Property</span>  Listings",
            desc: 'Monitor active property sale summaries and total platform listings instantly. Analyze interactive card action menus to optimize your entire operational system.',
        },
    ],

   similarProjects: [
    {
        id: 'pak-truck',
        title: 'Pak Truck',
        desc: "A responsive logistics website for trucking and fleet solutions.",
        image: 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1782816195/Tanbnil_uurjnc.png',
    },
    {
        id: 'we-scale-hq',
        title: 'We Scale HQ',
        desc: "Fix sales leaks, train teams, and scale business growth faster.",
        image: 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1782816247/Tanbnil_aqcabk.png',
    },
    {
        id: 'supply-king',
        title: 'Supply King',
        desc: "Simplify bulk ordering, supply management, and order tracking.",
        image: 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1782816196/Supply_king_kriepq.png',
    },
]
},

// Visaera WorldWide 

"visaera": {
    tag: 'web',
    color: '#016533',
    shadeColor1: '#C4763E80',
    shadeColor2: '#1C949566',

    thumbnail: visaera_thumb,
    topMedia: visaera_top,

    heroTag: 'Visa Services Platform',

    title: "Global <span class='text-[#333]'>Visa Assistance</span>",

    desc: 'Simplify international travel with a comprehensive platform that provides visa guidance, application support, and country-specific requirements.',

    leftContent: [
        {
            title: 'Explore Visa Destinations',
            desc: 'Navigate through an extensive list of global countries to find specific visa requirements tailored to your relocation goals.',
        },
        {
            title: 'Review Student Visas',
            desc: 'Check dedicated academic options and requirements for international students looking to secure admissions and study abroad seamlessly.',
        },
    ],

    rightContent: [
        {
            title: 'Discover E-Visa Options',
            desc: 'Explore modern digital travel authorizations and quick online visa categories available for eligible destination countries instantly.',
        },
        {
            title: 'Book Expert Consultation',
            desc: 'Schedule a professional one-on-one consultation session with immigration specialists to guide you through your application process.',
        },
    ],

    bottom: {
        title: 'Find Academic Guidance',
        desc: 'Access comprehensive institutional support and career counseling services designed to streamline your entire international educational journey.',
    },

    details: [
        {
            first: 'text',
            image1: visaera1,
            title: "Follow Our Visa Process Overview",
            desc: 'Follow each sequential step from the initial consultation and document preparation to processing updates and final visa delivery.',
        },
        {
            first: 'image',
            image1: visaera2,
            title: "Explore Available Global Visa Categories",
            desc: 'Browse through a comprehensive selection of travel, study, work, family, and long-term immigration visa options tailored to your destination goals.',
        },
        {
            first: 'text',
            image1: visaera3,
            title: "Start Your Visa Application Today",
            desc: 'Fill out the intake form to connect with experts who will guide you through study, work, or travel visa processes within 24 hours.',
        },
    ],

   similarProjects: [
    {
        id: 'flaty-web',
        title: 'Flaty Dashboard',
        desc: "Explore, buy, and sell properties with trusted listings and secure transactions.",
        image: 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1782816184/Tanbnil_yujxor.png',
    },
    {
        id: 'we-scale-hq',
        title: 'We Scale HQ',
        desc: "Fix sales leaks, train teams, and scale business growth faster.",
        image: 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1782816247/Tanbnil_aqcabk.png',
    },
    {
        id: 'supply-king',
        title: 'Supply King',
        desc: "Simplify bulk ordering, supply management, and order tracking.",
        image: 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1782816196/Supply_king_kriepq.png',
    },
]
},

// Field Trip Web 

"fieldtrip-link": {
    tag: 'web',
    color: '#2F80ED',
    shadeColor1: '#FF19194D',
    shadeColor1: '#FFAE004D',
    thumbnail: FieldTrip_thumb,
    topMedia: FieldTrip_top,
    heroTag: 'Dashboard Showcase',
    title: "Smart <span class='text-[#333]'>Field Trip</span> Management",
    desc: 'Simplify school transportation with real-time trip tracking, route management, and seamless communication between schools, drivers, and parents.',

    leftContent: [
        {
            title: 'Monitor Transportation Metrics',
            desc: 'Track your total scheduled trips, hired drivers, received proposals, and average driver ratings directly from the main dashboard overview.',
        },
        {
            title: 'Post New Trips',
            desc: 'Create and schedule brand new school field trips instantly to broadcast them for available transportation service providers.',
        },
    ],

    rightContent: [
        {
            title: 'Manage Upcoming Trips',
            desc: 'Review active schedules like morning pickup routes or museum visits while monitoring specific driver assignments and student headcounts.',
        },
        {
            title: 'Track Drivers Live',
            desc: 'Access real-time vehicle location tracking to ensure maximum safety and timely coordination during active school journeys.',
        },
    ],

    bottom: {
        title: 'View Received Proposals',
        desc: 'Browse through competitive bids and transport proposals submitted by service providers to choose the best option for your school.',
    },

    details: [
        {
            first: 'text',
            image1: FieldTrip1,
            title: "Manage Your User Chat History",
            desc: 'Navigate through your active contacts list and instantly send messages to maintain seamless real-time platform communication.',
        },
        {
            first: 'image',
            image1: FieldTrip2,
            title: "Browse Available School Transportation Rides",
            desc: 'Navigate through active school transportation requests, view route details, and submit direct service proposals to secure new ride contracts instantly.',
        },
        {
            first: 'text',
            image1: FieldTrip3,
            title: "Track Real-Time Live GPS Location",
            desc: 'Monitor your active school transit routes and track vehicle progression on the interactive map to ensure timely coordination.',
        },
    ],

   similarProjects: [
    {
        id: 'ubk-towing',
        title: 'UBK Towing',
        desc: 'Streamline transportation with vehicle management and inspections.',
        image: 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1782816201/Tanbnill_lb3ckm.png',
    },
    {
        id: 'earning-dashboard',
        title: 'Earning Dashboard',
        desc: 'Monitor revenue and financial performance in real-time.',
        image: 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1782110146/thumbnail_eh8biy.png',
    },
    {
        id: 'we-scale-hq',
        title: 'We Scale HQ',
        desc: 'Fix sales leaks, train teams, and scale business growth faster.',
        image: 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1782816247/Tanbnil_aqcabk.png',
    },
]
},

// Earning Dashbaord

"earning-dashboard": {
    tag: 'web',
    color: '#1E88E5',
    shadeColor1: '#3091C999',
    shadeColor2: '#00C26B66',
    thumbnail: EarningDashboard_thumb,
    topMedia: EarningDashboard_top,
    heroTag: 'Dashboard Showcase',
    title: "Smart <span class='text-[#333]'>Earning Dashboard</span> Analytics",
    desc: 'Monitor revenue, analyze performance, and manage financial insights through a powerful real-time analytics dashboard.',

    leftContent: [
        {
            title: 'Track Platform Earnings ',
            desc: 'View detailed financial revenue reports collected from all active towing system operations.',
        },
        {
            title: ' Analyze Driver Stats ',
            desc: 'Evaluate real-time breakdown distributions of total completed calls and driver metrics.',
        },
    ],

    rightContent: [
        {
            title: 'Track Fleet Statuses ',
            desc: ' Manage corporate vehicle inspections, driver profiles, and active fleet statuses effortlessly.',
        },
        {
            title: 'Manage Client Documents  ',
            desc: 'Organize comprehensive client billing forms and critical towing documentation securely online.',
        },
    ],

    bottom: {
        title: 'Filter Historical Data',
        desc: 'Customize your dashboard view to display financial summaries from the last month.',
    },

    details: [
        {
            first: 'text',
            image1: EarningDashboard1,
            title: "Track Your Active Driver Profiles ",
            desc: ' Monitor active cycle earnings summaries and total platform calls instantly. Analyze interactive driver performance tables to optimize your entire operational system. ',
        },
        {
            first: 'image',
            image1: EarningDashboard2,
            title: "Track Monthly Performance Metrics",
            desc: ' Monitor active cycle earnings summaries and total platform calls instantly. Analyze interactive client distribution charts to optimize your entire operational system.',
        },
        {
            first: 'text',
            image1: EarningDashboard3,
            title: "Complete Pre Trip Safety Checklist ",
            desc: 'Monitor active vehicle inspection forms and total vehicle details instantly. Analyze interactive items checklist tables to optimize your entire operational system.',
        },
    ],

   similarProjects: [
    {
        id: 'flaty-web',
        title: 'Flaty.pk',
        desc: "Explore, buy, and sell properties with trusted listings and secure transactions.",
        image: 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1782816184/Tanbnil_yujxor.png',
    },
    {
        id: 'supply-king',
        title: 'Supply King',
        desc: "Simplify bulk ordering, supply management, and order tracking.",
        image: 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1782816196/Supply_king_kriepq.png',
    },
    {
        id: 'we-scale-hq',
        title: 'We Scale HQ',
        desc: "Fix sales leaks, train teams, and scale business growth faster.",
        image: 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1782816247/Tanbnil_aqcabk.png',
    },
]
},
// Pak Truck 

"pak-truck": {
    tag: 'web',
    color: '#016533',
    shadeColor1: '#01663533',
    shadeColor2: '#01663566',

    thumbnail: pakTruck_thumb,
    topMedia: pakTruck_top,

    heroTag: 'Logistics Platform',

    title: "Smart <span class='text-[#333]'>Truck Management</span> Solution",

    desc: 'Manage transport operations, monitor deliveries, and streamline logistics with a powerful and user-friendly platform.',

    leftContent: [
        {
            title: 'Browse Various Categories',
            desc: 'Explore diverse heavy vehicle categories tailored perfectly to meet your business requirements.',
        },
        {
            title: 'Find Used Trucks',
            desc: 'Discover reliable pre-owned commercial trucks tailored perfectly to meet your transportation requirements.',
        },
    ],

    rightContent: [
        {
            title: 'Check Vehicle Prices',
            desc: 'View clear pricing and city locations tailored perfectly to meet your buying requirements.',
        },
        {
            title: 'Explore Sub Categories',
            desc: 'Navigate through specialized vehicle sub-categories tailored perfectly to meet your operational requirements.',
        },
    ],

    bottom: {
        title: 'Easy WhatsApp Support',
        desc: 'Connect instantly with active seller support tailored perfectly to meet your communication requiremen',
    },

    details: [
        {
            first: 'text',
            image1: pakTruck1,
            title: "Explore Commercial Used Truck Listings  ",
            desc: 'Connect with verified commercial vehicle dealers delivering top-quality transport options. Filter through available listings to find your perfect commercial truck or genuine spare parts across Pakistan. ',
        },
        {
            first: 'image',
            image1: pakTruck2,
            title: "Manage Your Received Buyer Messages ",
            desc: ' Connect with verified potential buyers delivering direct inquiries. Filter through top ads to track your perfect customer conversations and vehicle deals seamlessly.',
        },
        {
            first: 'text',
            image1: pakTruck3,
            title: "Verify Your Profile Identity Easily ",
            desc: 'Connect with verified platform features delivering secure authentication. Fill through required fields to find your perfect professional profile validation setup. ',
        },
    ],

   similarProjects: [
    {
        id: 'ubk-towing',
        title: 'UBK Towing',
        desc: "Streamline transportation with vehicle management and inspections.",
        image: 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1782816201/Tanbnill_lb3ckm.png',
    },
    {
        id: 'earning-dashboard',
        title: 'Earning Dashboard',
        desc: "Monitor revenue and financial performance in real-time.",
        image: 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1782816167/Add_main_Dashboard_-_Tanbnil_p7awef.png',
    },
    {
        id: 'developers-door',
        title: 'Developers Door',
        desc: "A modern platform for developers to learn and showcase projects.",
        image: 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1782816121/Tanbnil_qtlfyd.png',
    },
]
},

// Developers Door

"developers-door": {
    tag: "web",

    color: "#4A90E2",
    shadeColor1: "#35C6FF99",
    shadeColor2: "#A4E2FF66",

    thumbnail: DevelopersDoor_thumb,
    topMedia: DevelopersDoor_top,

    heroTag: "Developer Platform",

    title: "Modern <span class='text-[#333]'>Developer Community</span>",

    desc: "Discover developer resources, showcase projects, explore career opportunities, and connect with the tech community through a modern web platform.",

    leftContent: [
        {
            title: "Elite Vetted Teams ",
            desc: "Access trusted global software agencies to launch your next big technical project.",
        },
        {
            title: "Specialized Industry Niches ",
            desc: "Explore diverse development categories tailored perfectly to meet your business requirements.",
        },
    ],

    rightContent: [
        {
            title: "Live Performance Tracking ",
            desc: " Monitor active project development metrics and manage custom engineering proposals seamlessly.",
        },
        {
            title: "Milestone Budget Protection",
            desc: "Enjoy a clean, modern interface optimized for desktop, tablet, and mobile devices.",
        },
    ],

    bottom: {
        title: "Seamless Vendor Connection ",
        desc: "Post your technical project requirements for free to hire elite developers.",
    },

    details: [
        {
            first: "text",
            image1: DevelopersDoor1,
            title: "Connect With Top Expert Developers",
            desc: "Browse verified companies looking for professional talent. Post your technical projects for free, get noticed instantly, and pay only for real results.",
        },
        {
            first: "image",
            image1: DevelopersDoor2,
            title: "Partner With Leading Agency Experts",
            desc: "Connect directly with top-tier technical teams built to scale your business. From custom software to advanced engineering, find verified partners ready to bring your massive ideas to life.",
        },
        {
            first: "text",
            image1: DevelopersDoor3,
            title: " Explore Our Trusted Partner Companies",
            desc: "Connect with verified tech businesses delivering elite engineering. Filter through top categories to find your perfect professional software development team.",
        },
    ],

   similarProjects: [
    {
        id: "we-scale-hq",
        title: "We Scale HQ",
        desc: "Fix sales leaks, train teams, and scale business growth faster.",
        image: 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1782816247/Tanbnil_aqcabk.png',
    },
    {
        id: "supply-king",
        title: "Supply King",
        desc: "Simplify bulk ordering, supply management, and order tracking.",
        image: 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1782816196/Supply_king_kriepq.png',
    },
    {
        id: "visaera",
        title: "Visaera Worldwide",
        desc: "Access global visa guidance, applications, and travel requirements in one platform.",
        image: 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1782816205/Tanbnil_idqvvd.png',
    },
]
},

// Glasglow car Wash 
"glasgow-mobile-car-wash": {
    tag: "web",

    color: "#37A44B",
    shadeColor1: "#35C6FF99",
    shadeColor2: "#35C6FF66",

    thumbnail: Glassgow_thumb,
    topMedia: Glassgow_top,

    heroTag: "Car Wash Platform",

    title: "Professional <span class='text-[#37A44B]'>Mobile Car Wash</span> Service",

    desc: "Book reliable car washing and detailing services from anywhere with an intuitive web experience designed for convenience and efficiency.",

    leftContent: [
        {
            title: "Choose Car Valeting",
            desc: "Browse through premium mobile car washing and valeting services designed to clean your vehicle professionally at your doorstep.",
        },
        {
            title: "Filter Service Categories",
            desc: "Easily navigate between best sellers, standard valeting packages, and advanced detailing options using the top menu tabs.",
        },
    ],

    rightContent: [
        {
            title: "Discover Executive Touch",
            desc: "Select specialized exterior wash and protect packages tailored to give your car a thorough premium cleaning treatment.",
        },
        {
            title: "Achieve Showroom Finish",
            desc: "Explore top-tier detailing options that restore your vehicle's shine and deliver a flawless showroom quality appearance.",
        },
    ],

    bottom: {
        title: "Compare Package Prices",
        desc: "View clear pricing details on different service cards to choose the perfect package that fits your budget.",
    },

    details: [
        {
            first: "text",
            image1: Glassgow1,
            title: "View <span class = 'text-[#35C6FF]'>Professional Car Care</span> Gallery",
            desc: "Explore the remarkable before-and-after transformations achieved through our expert mobile car valeting and premium detailing services.",
        },
        {
            first: "image",
            image1: Glassgow2,
            title: "Send Us <span class = 'text-[#35C6FF]'>Your Inquiry</span> Message",
            desc: "Fill out our quick contact form with your vehicle details or reach out via email anytime to connect with our support team.",
        },
        {
            first: "text",
            image1: Glassgow3,
            title: "Choose <span class = 'text-[#35C6FF]'>Your Car Valeting</span> Package",
            desc: "Select from premium mobile car valeting services like Executive Touch or LuxClean mini to give your vehicle a professional wash and finish.",
        },
    ],

    similarProjects: [
    {
        id: "developers-door",
        title: "Developers Door",
        desc: "A modern platform for developers to learn, showcase projects, and explore careers.",
        image: 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1782816121/Tanbnil_qtlfyd.png',
    },
    {
        id: "visaera",
        title: "Visaera Worldwide",
        desc: "Access global visa guidance, applications, and travel requirements in one platform.",
        image: 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1782816205/Tanbnil_idqvvd.png',
    },
    {
        id: "pak-truck",
        title: "Pak Truck",
        desc: "A responsive logistics website for trucking and fleet solutions.",
        image: 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1782816195/Tanbnil_uurjnc.png',
    },
]
},

// SpecOptics //

"specoptics": {
    tag: "web",

    color: "#4A90D9",
    shadeColor1: "#5099FC4D",
    shadeColor2: "#3091C966",

    thumbnail: Specoptics_thumb,
    topMedia: Specoptics_top,

    heroTag: "Premium Eyewear",

    title: "Discover <span class='text-[#4A90D9]'>Premium Eyewear</span> Collection",

    desc: "Explore stylish frames, expert eye care, and designer brands through a seamless online optical shopping experience crafted for your vision and style.",

    leftContent: [
        {
            title: "Premium Eyewear Collection",
            desc: "Browse through stylish glasses frames options crafted carefully to enhance your personal fashion statement.",
        },
        {
            title: "Personalized Frame Fittings",
            desc: "Select from customized lens shapes adjustments designed accurately to ensure your absolute facial comfort.",
        },
    ],

    rightContent: [
        {
            title: "Designer Brand Partnerships",
            desc: "Discover exclusive luxury fashion glasses models launched recently to elevate your entire aesthetic look.",
        },
        {
            title: "Secure Online Ordering",
            desc: "Proceed through safe digital payment gateways integrated smoothly to finalize your retail purchase transactions.",
        },
    ],

    bottom: {
        title: "Expert Eye Care",
        desc: "Benefit from professional medical checkup routines scheduled intentionally to protect your lasting vision health.",
    },

    details: [
        {
            first: "image",
            image1: Specoptics1,
            title: "Professional <span class='text-[#4A90D9]'>Eyewear Repair Fitting</span> Services",
            desc: "Adjust customized optical frames and fix broken glasses elements instantly. Experience interactive physical adjustments to optimize your entire visual comfort system.",
        },
        {
            first: "text",
            image1: Specoptics2,
            title: "Claim <span class='text-[#4A90D9]'>Exclusive Special Discount</span> Offer",
            desc: "Unlock premium promotional eyewear sales and total brand frames instantly. Subscribe via active phone inputs to receive your entire retail savings.",
        },
        {
            first: "image",
            image1: Specoptics3,
            title: "Read Our <span class='text-[#4A90D9]'>Latest Expert</span> Blogs",
            desc: "Explore active eye care advice and total vision trends instantly. Read interactive medical lifestyle articles to optimize your entire optical health system.",
        },
    ],

    similarProjects: [
        {
            id: 'fitme',
            title: 'FitMe - AI Outfit Stylist',
            desc: 'AI-powered wardrobe app for smart outfit curation and planning.',
            image: 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1783593243/Tanbnil_tlfije.png',
        },
        {
            id: 'burn-mobile-tyres',
            title: 'Burn Mobile Tyres',
            desc: '24/7 emergency mobile tyre fitting across Birmingham.',
            image: 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1783593329/Tanbnil_nxxbnr.png',
        },
        {
            id: 'mobile-emissions',
            title: 'Mobile Emissions Testing',
            desc: 'On-site emission inspections for heavy trucks across the GTA.',
            image: 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1783593281/Tanbnil_f0paq7.png',
        },
    ],
},



// Burn Mobile 

"burn-mobile-tyres": {
    tag: "web",

    color: "#FF5722",
    shadeColor1: "#00008B4D",
    shadeColor2: "#3091C966",

    thumbnail: BurnMobile_thumb,
    topMedia: BurnMobile_top,

    heroTag: "Mobile Tyre Fitting",

    title: "24/7 <span class='text-[#FF5722]'>Mobile Tyre Fitting</span> Service",

    desc: "Access RAC-approved emergency tyre replacement and roadside assistance across Birmingham through a fast, intuitive booking experience.",

    leftContent: [
        {
            title: "Instant Emergency Dispatch",
            desc: "Request immediate roadside help and get an expert technician dispatched to your exact location within just 30-45 minutes.",
        },
        {
            title: "Premium Tyre Brands",
            desc: "Choose from a wide selection of world-renowned tyre brands, including Pirelli and Yokohama, for guaranteed safety and performance.",
        },
    ],

    rightContent: [
        {
            title: "RAC Approved Expertise",
            desc: "Trust in a certified, quality-assured service officially recognized by the RAC for professional 24/7 mobile tyre fitting solutions.",
        },
        {
            title: "Flexible Digital Payment",
            desc: "Enjoy the ultimate convenience of secure, cashless transactions using multiple payment methods like Apple or Google Pay.",
        },
    ],

    bottom: {
        title: "Read Real Customer Feedback",
        desc: "Explore authentic client reviews and genuine ratings to understand how we consistently maintain top-tier service standards.",
    },

    details: [
        {
            first: "text",
            image1: BurnMobile1,
            title: "Complete <span class = 'text-[#FF5722]'>Mobile Tyre Fitting</span> Services",
            desc: "Get expert tyre replacements and urgent roadside assistance delivered directly to your current location. Our skilled technicians arrive quickly to ensure you remain completely safe on every single journey.",
        },
        {
            first: "image",
            image1: BurnMobile2,
            title: "Explore Our <span class = 'text-[#FF5722]'>Premier Tyre Range</span>",
            desc: "Select from our vast inventory of branded tyres to find the perfect match for your vehicle's requirements and performance needs.",
        },
        {
            first: "text",
            image1: BurnMobile3,
            title: "Emergency <span class = 'text-[#FF5722]'>Roadside Flat Tyre</span> Assistance",
            desc: "Our mobile tyre experts remain available round the clock to get you moving again quickly. We cover all towns and major motorways across Birmingham to deliver prompt and reliable help.",
        },
    ],

  similarProjects: [
    {
        id: 'mobile-emissions',
        title: 'Mobile Emissions Testing',
        desc: 'On-site emission inspections for heavy trucks across the GTA.',
        image: 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1783593281/Tanbnil_f0paq7.png',
    },
    {
        id: 'fitme',
        title: 'FitMe - AI Outfit Stylist',
        desc: 'AI-powered wardrobe app for smart outfit curation and planning.',
        image: 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1783593243/Tanbnil_tlfije.png',
    },
    {
        id: 'specoptics',
        title: 'SpecOptics - Premium Eyewear',
        desc: 'Stylish frames, designer brands, and expert eye care online.',
        image: 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1783598196/SpecOptic_Tanbnil_glwmq9.png',
    },
]
},

// Mobile Emissions
"mobile-emissions": {
    tag: 'web',
    color: '#2E7D32',
    shadeColor1: '#5099FC4D',
    shadeColor2: '#3091C966',

    thumbnail: MobileEmissions_thumb,
    topMedia: MobileEmissions_top,

    heroTag: 'Fleet Emission Testing',

    title: "Certified <span class='text-[#2E7D32]'>Mobile Emission</span> Testing",

    desc: 'Access on-site certified emission inspections for heavy trucks and commercial fleets across the GTA with fast booking and instant digital reports.',

    leftContent: [
        {
            title: 'On-Site Emissions Testing',
            desc: 'Experience hassle-free certified inspections for your heavy trucks and industrial vehicles directly at your location.',
        },
        {
            title: 'Certified Fleet Compliance',
            desc: 'Ensure your entire commercial fleet fully meets the official environmental standards and regional regulatory requirements.',
        },
    ],

    rightContent: [
        {
            title: 'Fast Appointment Booking',
            desc: 'Schedule your preferred time slot quickly using our streamlined and user-friendly online booking system.',
        },
        {
            title: 'Full GTA Coverage',
            desc: 'Access prompt mobile testing solutions seamlessly across the entire Toronto area and surrounding regions.',
        },
    ],

    bottom: {
        title: 'Quick Thirty-Minute Tests',
        desc: 'Receive comprehensive and highly accurate digital reports completed efficiently within just thirty minutes.',
    },

    details: [
        {
            first: 'text',
            image1: MobileEmissions1,
            title: "Certified Heavy Duty Emission Testing",
            desc: 'Deliver reliable mobile inspections for commercial trucks to eliminate compliance risks and secure verified digital reports that seamlessly fulfill regional fleet environmental standards.',
        },
        {
            first: 'image',
            image1: MobileEmissions2,
            title: "Streamline Your Fleet Compliance Today",
            desc: 'Partner with licensed mobile inspectors to access flexible on-site scheduling, transparent competitive pricing, and certified emissions testing designed to protect your operational efficiency.',
        },
        {
            first: 'text',
            image1: MobileEmissions3,
            title: "Our Simple Process Explained Clearly",
            desc: 'Book your preferred slot, experience expert on-site testing delivered by licensed technicians, and receive certified compliance documentation instantly without any operational hassle.',
        },
    ],

similarProjects: [
    {
        id: 'burn-mobile-tyres',
        title: 'Burn Mobile Tyres',
        desc: '24/7 emergency mobile tyre fitting across Birmingham.',
        image: 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1783593329/Tanbnil_nxxbnr.png',
    },
    {
        id: 'specoptics',
        title: 'SpecOptics - Premium Eyewear',
        desc: 'Stylish frames, designer brands, and expert eye care online.',
        image: 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1783598196/SpecOptic_Tanbnil_glwmq9.png',
    },
    {
        id: 'fitme',
        title: 'FitMe - AI Outfit Stylist',
        desc: 'AI-powered wardrobe app for smart outfit curation and planning.',
        image: 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1783593243/Tanbnil_tlfije.png',
    },
]
},

// OXZ Market 

"oxz-market": {
    tag: 'web',
    color: '#D4A017',
    shadeColor1: '#5099FC4D',
    shadeColor2: '#3091C966',

    thumbnail: OXZMarket_hero,
    topMedia: OXZMarke_top,

    heroTag: 'Online Trading Platform',

    title: "Trade <span class='text-[#D4A017]'>Global Forex</span> & Assets",

    desc: 'Access powerful trading tools, real-time market execution, and expert analytical reports through a trusted online broker platform designed for global investors.',

    leftContent: [
        {
            title: 'Advanced Trading Tools',
            desc: 'Access powerful technical indicators designed perfectly to maximize your global market investment returns.',
        },
        {
            title: 'Secure Digital Wallet',
            desc: 'Protect your valuable financial assets utilizing premium encryption protocols built for maximum safety.',
        },
    ],

    rightContent: [
        {
            title: 'Instant Market Execution',
            desc: 'Execute vital currency trades seamlessly without experiencing any stressful delays or costly slippage.',
        },
        {
            title: 'Global Forex Access',
            desc: 'Trade major international currency pairs easily through our highly trusted online broker platform.',
        },
    ],

    bottom: {
        title: 'Expert Analytical Reports',
        desc: 'Receive real-time financial data insights tailored explicitly to improve your trading strategy.',
    },

    details: [
        {
            first: 'text',
            image1: OXZMarket1,
            title: "Trade Securely With Trusted Broker",
            desc: 'Access advanced charts, utilize reliable currency execution tools, and leverage expert financial insights designed to protect your valuable market investments seamlessly end to end.',
        },
        {
            first: 'image',
            image1: OXZMarket2,
            title: "Earn Competitive Affiliate Program Commissions",
            desc: 'Unlock outstanding partnership opportunities with our trusted referral network to secure passive financial rewards while effortlessly promoting reliable global trading products and services.',
        },
        {
            first: 'text',
            image1: OXZMarket3,
            title: "Explore Diverse Global Trading Assets",
            desc: 'Maximize your financial portfolio by seamlessly trading top performing stocks, popular foreign currencies, valuable raw commodities, and emerging high growth cryptocurrencies on our advanced platform.',
        },
    ],

  similarProjects: [
    {
        id: 'mb-travel',
        title: 'MB Travel - Visa & Immigration',
        desc: 'Smart visa applications with secure document uploads and tracking.',
        image: 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1783669931/MB_Travel_Tanbnil_kyswqf.png',
    },
    {
        id: 'mego',
        title: 'MEGO - Buy & Sell Marketplace',
        desc: 'Classified marketplace for smartphones, cars, and properties.',
        image: 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1783593156/Tanbnil_yoqi3j.png',
    },
    {
        id: 'specoptics',
        title: 'SpecOptics - Premium Eyewear',
        desc: 'Stylish frames, designer brands, and expert eye care online.',
        image: 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1783598196/SpecOptic_Tanbnil_glwmq9.png',
    },
]
},
// Sohagan
"sohagan": {
    tag: 'web',
    color: '#B8860B',
    shadeColor1: '#E4A4004D',
    shadeColor2: '#E4A40066',

    thumbnail: sohagan_hero,
    topMedia: sohagan_top,

    heroTag: 'Luxury Jewellery Platform',

    title: "Timeless <span class='text-[#B8860B]'>Handcrafted</span> Jewellery",

    desc: 'Browse through luxury bridal jewellery, premium gold collections, and exclusive custom designs with secure online shopping and worldwide insured shipping.',

    leftContent: [
        {
            title: 'Timeless Handcrafted Pieces',
            desc: 'Browse through luxury bridal jewellery options crafted perfectly to meet your traditional wedding requirements.',
        },
        {
            title: 'Premium Gold Collections',
            desc: 'Access authentic certified metal asset deals sourced perfectly to meet your personal styling requirements.',
        },
    ],

    rightContent: [
        {
            title: 'Exclusive Custom Designs',
            desc: 'Select unique heritage necklace ring sets tailored perfectly to meet your aesthetic fashion requirements.',
        },
        {
            title: 'Secure Online Shopping',
            desc: 'Proceed through safe digital payment portal setups structured perfectly to meet your retail purchase requirements.',
        },
    ],

    bottom: {
        title: 'Worldwide Insured Shipping',
        desc: 'Receive fine valuable luxury parcel shipments refined perfectly to meet your global delivery requirements.',
    },

    details: [
        {
            first: 'text',
            image1: sohagan1,
            title: "Explore Exclusive <span class = 'text-[#B8860B]'>Artisan Bracelet</span> Collections",
            desc: 'Browse handcrafted leather and gold wristwear varieties instantly. Categorize interactive luxury jewelry showcases to optimize your complete shopping experience.',
        },
        {
            first: 'image',
            image1: sohagan2,
            title: "Integrated Express <span class = 'text-[#B8860B]'>Buy & Cart</span> Workflow",
            desc: "Implemented custom size selectors, color swatches, and real-time stock counters. Developed multi-angle thumbnail carousels alongside instant 'Add to Cart' and direct 'Buy It Now' buttons.",
        },
        {
            first: 'text',
            image1: sohagan3,
            title: "Developed Advanced <span class = 'text-[#B8860B]'>Filtering & Catalog</span> Listing Page",
            desc: 'Built dynamic sidebars for stock availability, price range inputs, and size selection. Integrated custom sorting dropdowns (alphabetical/price) along with dynamic "Sale" product grid cards.',
        },
    ],

   similarProjects: [
    {
        id: 'specoptics',
        title: 'SpecOptics - Premium Eyewear',
        desc: 'Stylish frames, designer brands, and expert eye care online.',
        image: 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1783598196/SpecOptic_Tanbnil_glwmq9.png',
    },
    {
        id: 'fitme',
        title: 'FitMe - AI Outfit Stylist',
        desc: 'AI-powered wardrobe app for smart outfit curation and planning.',
        image: 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1783593243/Tanbnil_tlfije.png',
    },
    {
        id: "diamond-yarn",
        title: "Diamond Yarn - Premium Yarns",
        desc: 'Luxury knitting threads, handcrafted needles, and curated patterns.',
        image: "https://res.cloudinary.com/dxsr1xve0/image/upload/v1783604550/Tanbnill_yeu6sr.png",
    },
]
},

// Diamond Yarn 
"diamond-yarn": {
    tag: 'web',
    color: '#6A1B9A',
    shadeColor1: '#8958804D',
    shadeColor2: '#8958804D',

    thumbnail: DiamondYarn_hero,
    topMedia: DiamondYarn_top,

    heroTag: 'Premium Yarn Platform',

    title: "Premium <span class='text-[#6A1B9A]'>Quality Yarns</span> & Accessories",

    desc: 'Browse through luxury knitting threads, official brand distributions, handcrafted needles, curated patterns, and universal fiber accessories for all your creative crafting needs.',

    leftContent: [
        {
            title: 'Premium Quality Yarns',
            desc: 'Browse through luxury knitting threads options crafted perfectly to meet your creative crafting requirements.',
        },
        {
            title: 'Official Brand Distribution',
            desc: 'Access authentic global textile label deals sourced perfectly to meet your wholesale manufacturing requirements.',
        },
    ],

    rightContent: [
        {
            title: 'Handcrafted Knitting Needles',
            desc: 'Select durable ergonomic stitching tool sets tailored perfectly to meet your professional production requirements.',
        },
        {
            title: 'Beautiful Curated Patterns',
            desc: 'Discover custom weaving design guide layouts structured perfectly to meet your artistic project requirements.',
        },
    ],

    bottom: {
        title: 'Universal Fiber Accessories',
        desc: 'Order fine organic spinning material choices refined perfectly to meet your seasonal design requirements.',
    },

    details: [
        {
            first: 'text',
            image1: DiamondYarn1,
            title: "Engineered <span class = 'text-[#6A1B9A]'>Dynamic Product</span>  Details Page",
            desc: 'Integrated custom quantity selectors and interactive color variant swatches. Developed an add-to-cart workflow with product comparison features to streamline shopping',
        },
        {
            first: 'image',
            image1: DiamondYarn2,
            title: "Developed Interactive  <span class = 'text-[#6a1b9a]'>Product Customization</span> View",
            desc: 'Implemented structured product attribute layouts featuring composition metrics and material sizing data. Designed responsive thumbnail galleries with direct product comparison triggers to enhance usability.',
        },
        {
            first: 'text',
            image1: DiamondYarn3,
            title: "Built <span class = 'text-[#6a1b9a]'> Custom Wholesale</span> Application Form",
            desc: 'Engineered input forms for business details, registration, and contact information. Integrated front-end validation with instant form submission actions.',
        },
    ],

    similarProjects: [
    {
        id: 'sohagan',
        title: 'Sohagan - Luxury Jewellery',
        desc: 'Timeless handcrafted bridal jewellery and premium gold collections.',
        image: 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1783604502/Tanbnill_k1jaug.png',
    },
    {
        id: 'specoptics',
        title: 'SpecOptics - Premium Eyewear',
        desc: 'Stylish frames, designer brands, and expert eye care online.',
        image: 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1783598196/SpecOptic_Tanbnil_glwmq9.png',
    },
    {
        id: 'fitme',
        title: 'FitMe - AI Outfit Stylist',
        desc: 'AI-powered wardrobe app for smart outfit curation and planning.',
        image: 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1783593243/Tanbnil_tlfije.png',
    },
]
},

// VendComm
"vendcomm": {
    tag: 'web',
    color: '#0D47A1',
    shadeColor1: '#3182ED4D',
    shadeColor2: '#3182ED4D',

    thumbnail: VendComm_hero,
    topMedia: VendComm_top,

    heroTag: 'Event Management Platform',

    title: "Streamline <span class='text-[#0D47A1]'>Vendor Communications</span> & Events",

    desc: 'Centralize invoices, manage vendor communications, track event timelines, and streamline team coordination through a powerful event management platform.',

    leftContent: [
        {
            title: 'Centralize All Invoices',
            desc: 'Navigate through secure billing payment deals tailored perfectly to meet your operational requirements.',
        },
        {
            title: 'Manage Vendor Communications',
            desc: 'Connect through unified interactive conversation logs tailored perfectly to meet your operational requirements.',
        },
    ],

    rightContent: [
        {
            title: 'Track Event Timelines',
            desc: 'Monitor through precise digital schedule tracking tools tailored perfectly to meet your operational requirements.',
        },
        {
            title: 'Secure Early Access',
            desc: 'Register through official premium waitlist portal signups tailored perfectly to meet your operational requirements.',
        },
    ],

    bottom: {
        title: 'Streamline Team Coordination',
        desc: 'Organize through efficient automated workflow management platforms tailored perfectly to meet your operational requirements.',
    },

    details: [
        {
            first: 'text',
            image1: VendComm1,
            title: "Solve Your Event Management Challenges",
            desc: 'Monitor active project workflow histories and total vendor profiles instantly. Analyze interactive corporate transformation lists to optimize your entire system.',
        },
        {
            first: 'image',
            image1: VendComm2,
            title: "Explore Our Key Platform Features",
            desc: 'Monitor active vendor communication histories and total project budgets instantly. Analyze interactive digital marketing lists to optimize your entire event system.',
        },
        {
            first: 'text',
            image1: VendComm3,
            title: "Choose Your Perfect Pricing Plans",
            desc: 'Monitor active subscription tier histories and total package details instantly. Analyze interactive corporate budget lists to optimize your entire event system.',
        },
    ],

    similarProjects: [
    {
        id: 'diamond-yarn',
        title: 'Diamond Yarn - Premium Yarns',
        desc: 'Luxury knitting threads, handcrafted needles, and curated patterns.',
        image: 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1783604550/Tanbnill_yeu6sr.png',
    },
    {
        id: 'sohagan',
        title: 'Sohagan - Luxury Jewellery',
        desc: 'Timeless handcrafted bridal jewellery and premium gold collections.',
        image: 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1783604502/Tanbnill_k1jaug.png',
    },
    {
        id: 'specoptics',
        title: 'SpecOptics - Premium Eyewear',
        desc: 'Stylish frames, designer brands, and expert eye care online.',
        image: 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1783598196/SpecOptic_Tanbnil_glwmq9.png',
    },
]
},

// vendcomm Dashbaord 
"vendcomm-dashboard": {
    tag: 'web',
    color: '#1565C0',
    shadeColor1: '#3182ED66',
    shadeColor2: '#3182ED4D',

    thumbnail: VendCommDashboard_hero,
    topMedia: VendCommDashboard_top,

    heroTag: 'Vendor Management Dashboard',

    title: "Manage <span class='text-[#1565C0]'>Vendor Campaigns</span> & Budgets",

    desc: 'Streamline marketing campaigns, track event budgets, assign portal tasks, connect stakeholders, and generate digital invoices through a powerful vendor management dashboard.',

    leftContent: [
        {
            title: 'Manage Marketing Campaigns',
            desc: 'Navigate through secure promotional launch deals tailored perfectly to meet your operational requirements.',
        },
        {
            title: 'Track Event Budgets',
            desc: 'Monitor through precise corporate financial allocation setups tailored perfectly to meet your operational requirements.',
        },
    ],

    rightContent: [
        {
            title: 'Assign Portal Tasks',
            desc: 'Delegate through direct executive activity tracking workflows tailored perfectly to meet your operational requirements.',
        },
        {
            title: 'Connect Campaign Stakeholders',
            desc: 'Collaborate through unified internal team contact portals tailored perfectly to meet your operational requirements.',
        },
    ],

    bottom: {
        title: 'Generate Digital Invoices',
        desc: 'Process through automated client billing history reports tailored perfectly to meet your operational requirements.',
    },

    details: [
        {
            first: 'text',
            image1: VendCommDashboard1,
            title: "Streamline Your Vendor Project Tasks",
            desc: 'Monitor active project task histories and total platform progress instantly. Analyze interactive corporate activity lists to optimize your entire event system.',
        },
        {
            first: 'image',
            image1: VendCommDashboard2,
            title: "Manage Your Active Vendor Chats",
            desc: 'Monitor active user chat histories and total platform messages instantly. Analyze interactive active contact lists to optimize your entire communication system.',
        },
        {
            first: 'text',
            image1: VendCommDashboard3,
            title: "Track Your Platform Vendor Profiles",
            desc: 'Monitor active vendor service histories and total profile details instantly. Analyze interactive service category lists to optimize your entire event system.',
        },
    ],

   similarProjects: [
    {
        id: 'vendcomm',
        title: 'VendComm - Event Management',
        desc: 'Centralize invoices, manage vendor communications, and track events.',
        image: 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1783604655/Tanbnill_iy8ld7.png',
    },
    {
        id: 'diamond-yarn',
        title: 'Diamond Yarn - Premium Yarns',
        desc: 'Luxury knitting threads, handcrafted needles, and curated patterns.',
        image: 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1783604550/Tanbnill_yeu6sr.png',
    },
    {
        id: 'sohagan',
        title: 'Sohagan - Luxury Jewellery',
        desc: 'Timeless handcrafted bridal jewellery and premium gold collections.',
        image: 'https://res.cloudinary.com/dxsr1xve0/image/upload/v1783604502/Tanbnill_k1jaug.png',
    },
]
},


    
   
}

export default ProjectsData
